// TODO temporarily disable eslint on this file until v1.0 Unwired is complete/services are used
/* eslint @typescript-eslint/no-unused-vars: "off" */
/* eslint @typescript-eslint/no-explicit-any: "off" */
/* eslint @typescript-eslint/no-non-null-assertion: "off" */
// QueryService
import { DocumentNode, gql } from "@apollo/client";

import { OrganisationType } from "../../models";
import { generateGraphQLHelpers, insertAfterSubstring, jsonReviver, SearchResultsGraphQL } from "../../utils";
import { apolloPrivate } from "../apolloPrivate";
import { BaseResponseWithMultiple, BaseResponseWithSingle, FilterGroups, ServiceError, Status } from "../Shared";
import {
  GetActivityAggregateRequest,
  GetActivityAggregateResponse,
  GetActivityDefinitionVersionDetailsRequest,
  GetActivityDefinitionVersionDetailsResponse,
  GetActivityDetailsRequest,
  GetActivityDetailsResponse,
  GetActivityHistoryDetailsRequest,
  GetActivityHistoryDetailsResponse,
  GetActivityReviewAggregateRequest,
  GetActivityReviewAggregateResponse,
  GetActivityReviewDetailsRequest,
  GetActivityReviewDetailsResponse,
  GetAggregateIssuancesRequest,
  GetAggregateIssuancesResponse,
  GetAggregateWorkflowTasksRequest,
  GetAggregateWorkflowTasksResponse,
  GetAssetManagerDetailsRequest,
  GetAssetManagerDetailsResponse,
  GetAuditDataDetailsRequest,
  GetAuditDataDetailsResponse,
  GetCurrentUserGroupPermissionRequest,
  GetCurrentUserGroupPermissionResponse,
  GetCurrentUserProjectPermissionsRequest,
  GetCurrentUserProjectPermissionsResponse,
  GetCurrentUserResponse,
  GetDealRequest,
  GetDealResponse,
  GetDeveloperDetailsRequest,
  GetDeveloperDetailsResponse,
  GetDevelopmentManagerDetailsRequest,
  GetDevelopmentManagerDetailsResponse,
  GetDiscussionThreadsRequest,
  GetDiscussionThreadsResponse,
  GetGroupDetailsRequest,
  GetGroupDetailsResponse,
  GetObjectDocumentsRequest,
  GetObjectDocumentsResponse,
  GetOrganisationDetailsRequest,
  GetOrganisationDetailsResponse,
  GetOrganisationEmbeddingPreferencesRequest,
  GetOrganisationEmbeddingPreferencesResponse,
  GetOrganisationsForDiscussionRequest,
  GetOrganisationsForDiscussionResponse,
  GetOrganisationUserDetailsRequest,
  GetOrganisationUserDetailsResponse,
  GetPipelineAggregateRequest,
  GetPipelineAggregateResponse,
  GetPortfolioRequest,
  GetPortfolioResponse,
  GetProjectAggregateRequest,
  GetProjectAggregateResponse,
  GetProjectDetailsRequest,
  GetProjectDetailsResponse,
  GetProjectDocumentVersionRequest,
  GetProjectDocumentVersionResponse,
  GetProjectIssuancesRequest,
  GetProjectIssuancesResponse,
  GetProjectOrganisationInvitationDetailsRequest,
  GetProjectOrganisationInvitationDetailsResponse,
  GetStandardDetailsRequest,
  GetStandardDetailsResponse,
  GetStandardSpecificSchemaDetailsRequest,
  GetStandardSpecificSchemaDetailsResponse,
  GetStatsAggregateRequest,
  GetStatsAggregateResponse,
  GetTaskBoardRequest,
  GetTaskBoardResponse,
  GetVerifierDetailsRequest,
  GetVerifierDetailsResponse,
  GetWorkflowTemplateRequest,
  GetWorkflowTemplateResponse,
  LookUpRequest,
  LookUpResponse,
  SearchAclEntriesRequest,
  SearchAclEntriesResponse,
  SearchActivitiesRequest,
  SearchActivitiesResponse,
  SearchActivityDefinitionDocumentTypesRequest,
  SearchActivityDefinitionDocumentTypesResponse,
  SearchActivityDefinitionsRequest,
  SearchActivityDefinitionsResponse,
  SearchActivityDocumentsRequest,
  SearchActivityDocumentsResponse,
  SearchActivityHistoryRequest,
  SearchActivityHistoryResponse,
  SearchActivityReviewsRequest,
  SearchActivityReviewsResponse,
  SearchAuditDataRequest,
  SearchAuditDataResponse,
  SearchCollaboratorsRequest,
  SearchCollaboratorsResponse,
  SearchDealDocumentHistoryRequest,
  SearchDealDocumentHistoryResponse,
  SearchDealDocumentsRequest,
  SearchDealDocumentsResponse,
  SearchDealSpecificSchemasRequest,
  SearchDealSpecificSchemasResponse,
  SearchDevelopersRequest,
  SearchDevelopersResponse,
  SearchDiscussionThreadsRequest,
  SearchDiscussionThreadsResponse,
  SearchInteractionsRequest,
  SearchInteractionsResponse,
  SearchIssuanceTransactionsRequest,
  SearchIssuanceTransactionsResponse,
  SearchNotificationsRequest,
  SearchNotificationsResponse,
  SearchOrganisationsRequest,
  SearchOrganisationsResponse,
  SearchOrganisationUsersRequest,
  SearchOrganisationUsersResponse,
  SearchPipelineDealsRequest,
  SearchPipelineDealsResponse,
  SearchProjectDocumentHistoryRequest,
  SearchProjectDocumentHistoryResponse,
  SearchProjectDocumentsRequest,
  SearchProjectDocumentsResponse,
  SearchProjectDocumentTypesRequest,
  SearchProjectDocumentTypesResponse,
  SearchProjectDocumentTypeVariantsRequest,
  SearchProjectDocumentTypeVariantsResponse,
  SearchProjectLocationsRequest,
  SearchProjectLocationsResponse,
  SearchProjectOrganisationInvitationsRequest,
  SearchProjectOrganisationInvitationsResponse,
  SearchProjectOrganisationsRequest,
  SearchProjectOrganisationsResponse,
  SearchProjectsRequest,
  SearchProjectsResponse,
  SearchProjectTrackerRequest,
  SearchProjectTrackerResponse,
  SearchStandardsRequest,
  SearchStandardsResponse,
  SearchVerifiersRequest,
  SearchVerifiersResponse,
  SearchWorkflowTaskMilestonesResponse,
  SearchWorkflowTaskObjectGroupsRequest,
  SearchWorkflowTaskObjectGroupsResponse,
  SearchWorkflowTasksRequest,
  SearchWorkflowTasksResponse,
  SearchWorkflowTemplatesRequest,
  SearchWorkflowTemplatesResponse,
  SearchWorkflowTemplateTasksRequest,
  SearchWorkflowTemplateTasksResponse,
} from "./Types";

export const getAuditDataDetails = async (
  req: GetAuditDataDetailsRequest
): Promise<BaseResponseWithSingle<GetAuditDataDetailsResponse>> => {
  const variables = { auditDataUuid: req.auditDataUuid };

  const QUERY = `
    query ($auditDataUuid: UUID!) {
      auditDataDetails(
        auditDataUuid: $auditDataUuid
      ) {
        eventDateTime
        metaData
        userFullName
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.auditDataDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchAuditData = async (
  req: SearchAuditDataRequest & FilterGroups<SearchAuditDataRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchAuditDataResponse>> => {
  const graphqlTypes = {
    id: "Int!",
    type: "String!",
    objectType: "String!",
    objectUuid: "[UUID]",
    detail: "String",
    action: "String!",
    userFullName: "String",
    "project.projectUuid": "UUID",
    "project.projectName": "String",
    "projectGroup.projectGroupUuid": "UUID",
    "organisation.organisationUuid": "UUID",
    "appUser.userUuid": "UUID",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  const QUERY = `
    query (${variablesBlock}) {
      searchAuditData(
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          node {
            id
            uuid
            action
            detail
            eventDateTime
            objectType
            objectUuid
            type
            userFullName
            project {
                projectName
                projectUuid
            }
            projectGroup {
                projectGroupName
                projectGroupUuid
            }
            organisation {
                organisationName
                organisationUuid
            }
            appUser {
                userFullName
                userUuid
            }
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchAuditData as SearchResultsGraphQL<SearchAuditDataResponse["results"][number]>;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectOrganisations = async (
  req: SearchProjectOrganisationsRequest
): Promise<BaseResponseWithSingle<SearchProjectOrganisationsResponse>> => {
  if (!req.projectUuid && !req.groupUuid) {
    return {
      status: Status.Error,
      errors: [
        {
          code: "ValidationError",
          message: "Either projectUuid or groupUuid is required.",
          parameters: undefined,
          path: "projectUuid",
          property: "projectUuid",
        },
      ],
    };
  }

  const graphqlTypes = {
    role: "[String]",
    organisationUuid: "UUID",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  const queryVariables = [
    req.projectUuid ? "$projectUuid: UUID" : "",
    req.groupUuid ? "$groupUuid: UUID" : "",
    variablesBlock,
  ]
    .filter(Boolean)
    .join(", ");
  const requestVariables = [
    req.projectUuid ? "projectUuid: $projectUuid" : "",
    req.groupUuid ? "groupUuid: $groupUuid" : "",
  ]
    .filter(Boolean)
    .join(", ");

  if (req.projectUuid) variables.projectUuid = req.projectUuid;
  if (req.groupUuid) variables.groupUuid = req.groupUuid;
  variables.role = req.filter?.results?.role?.value.split(", ");
  const QUERY = `
    query (${queryVariables}) {
      searchProjectOrganisations(
        request: {${requestVariables}}
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          node {
            organisationUuid
            displayName
            role
            organisationType
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectOrganisations as SearchResultsGraphQL<
        SearchProjectOrganisationsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectDocumentTypes = async (
  req: SearchProjectDocumentTypesRequest
): Promise<BaseResponseWithSingle<SearchProjectDocumentTypesResponse>> => {
  const standardUuidGraphqlType = req.filter?.results?.standard?.standardUuid?.value
    ?.split(", ")
    .map((value) => (value === "null" ? null : value))
    ? "[UUID]"
    : "UUID";
  const graphqlTypes = {
    "standard.standardUuid": standardUuidGraphqlType,
    "standard.displayName": "String",
    name: "String!",
    uuid: "UUID!",
    isGenerated: "Boolean",
  };

  const [queryBlock, variablesBlockConstant, variables] = generateGraphQLHelpers(req, graphqlTypes);

  // split string into array and swap "null" for null
  variables.standardStandardUuid = req.filter?.results?.standard?.standardUuid?.value
    ?.split(", ")
    .map((value) => (value === "null" ? null : value));

  const QUERY = `
    query (${variablesBlockConstant}) {
      searchProjectDocumentTypes(
        ${queryBlock}
      ) {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
          edges {
            cursor
            node {
              id
              uuid
              name
              supportsVariants
              supportsMultipleFiles
              supportedMimeTypes
              maxFileSize
              isGenerated
              description
              standard {
                  standardUuid
                  displayName
              }
            }
          }
          aspects {
            standards {
              standardUuid
              displayName
            }
          }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectDocumentTypes as SearchResultsGraphQL<
        SearchProjectDocumentTypesResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      const aspects = (data as any).aspects ?? [];

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
          aspects,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectDocumentTypeVariants = async (
  req: SearchProjectDocumentTypeVariantsRequest
): Promise<BaseResponseWithSingle<SearchProjectDocumentTypeVariantsResponse>> => {
  const graphqlTypes = {
    typeUuid: "UUID",
    name: "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query (${variablesBlock}) {
      searchProjectDocumentTypeVariants(
        ${queryBlock}
      ) {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
          edges {
            cursor
            node {
              id
              uuid
              name
              description
              typeUuid
            }
          }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectDocumentTypeVariants as SearchResultsGraphQL<
        SearchProjectDocumentTypeVariantsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectDocuments = async (
  req: SearchProjectDocumentsRequest
): Promise<BaseResponseWithSingle<SearchProjectDocumentsResponse>> => {
  const graphqlTypes = {
    uuid: "UUID!",
    "updatedByUser.fullName": "String!",
    "updatedByUser.firstName": "String!",
    "updatedByUser.lastName": "String!",
    updatedAt: "DateTime!",
    type: "String!",
    visibility: "String!",
    variant: "String",
    customVariant: "[String]",
    version: "Int!",
    activityName: "String!",
    "file.filename": "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  variables.projectUuid = req.projectUuid;
  variables.groupUuid = req.groupUuid;
  const QUERY = `
    query ($projectUuid: UUID, $groupUuid: UUID, ${variablesBlock}) {
      searchProjectDocuments(
        projectUuid: $projectUuid
        groupUuid: $groupUuid
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            file {
              filename
              url
              mimeType
              sizeBytes
              uuid
            }
            activityName
            visibility
            version
            versionCount
            versionUuid
            groupId
            updatedAt
            updatedByUser {
                firstName
                lastName
                fullName
                avatar {
                    url
                }
            }
            type
            variant
            customVariant
            uuid
            projectName
            projectUuid
            groupName
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectDocuments as SearchResultsGraphQL<
        SearchProjectDocumentsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchDealDocuments = async (
  req: SearchDealDocumentsRequest
): Promise<BaseResponseWithSingle<SearchDealDocumentsResponse>> => {
  const graphqlTypes = {
    "createdByUser.fullName": "String!",
    customVariant: "String!",
    documentType: "String!",
    uuid: "UUID!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.dealUuid = req.dealUuid;
  const QUERY = `
    query ($dealUuid: UUID!, ${variablesBlock}) {
      searchDealDocuments(
        dealUuid: $dealUuid
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            customVariant
            documentType
            latestVersion
            createdByUser {
              email
              fullName
            }
            file {
              fileName
              mimeType
              sizeBytes
              url
              uuid
            }
            uuid
            versionUuid
            createdAt
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchDealDocuments as SearchResultsGraphQL<
        SearchDealDocumentsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchDealDocumentHistory = async (
  req: SearchDealDocumentHistoryRequest
): Promise<BaseResponseWithSingle<SearchDealDocumentHistoryResponse>> => {
  const graphqlTypes = {
    "createdByUser.fullName": "String!",
    customVariant: "String!",
    documentType: "String!",
    "file.fileName": "String!",
    version: "Int!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.dealDocumentUuid = req.dealDocumentUuid;
  const QUERY = `
    query ($dealDocumentUuid: UUID!, ${variablesBlock}) {
      searchDealDocumentHistory(
        dealDocumentUuid: $dealDocumentUuid
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            customVariant
            documentType
            version
            createdAt
            createdByUser {
              email
              fullName
            }
            file {
              fileName
              mimeType
              sizeBytes
              url
              uuid
            }
            uuid
            createdAt
            rowVersion
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchDealDocumentHistory as SearchResultsGraphQL<
        SearchDealDocumentHistoryResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getProjectDocumentVersion = async (
  req: GetProjectDocumentVersionRequest
): Promise<BaseResponseWithSingle<GetProjectDocumentVersionResponse>> => {
  const variables = { projectDocumentHistoryUuid: req.projectDocumentHistoryUuid };

  const QUERY = `
    query ($projectDocumentHistoryUuid: UUID!) {
      projectDocumentVersion(
        projectDocumentHistoryUuid: $projectDocumentHistoryUuid
      ) {
        uuid
        customVariant
        version
        visibility
        groupId
        documentRowVersion
        rowVersion
        standardApproved
        documentType {
            uuid
            name
            maxFileSize
            supportedMimeTypes
            supportsVariants
        }
        documentVariant {
            uuid
            name
        }
        relatedOrganisations {
            displayName
            uuid
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.projectDocumentVersion[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjects = async (
  req: SearchProjectsRequest & FilterGroups<SearchProjectsRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchProjectsResponse>> => {
  const graphqlTypes = {
    "assetManager.displayName": "String!",
    "developer.displayName": "String!",
    "developer.uuid": "UUID!",
    "developmentManager.displayName": "String!",
    "standard.displayName": "String!",
    "standard.uuid": "UUID!",
    "projectType.displayName": "String!",
    "projectType.uuid": "UUID!",
    "validator.displayName": "String!",
    "validator.uuid": "UUID",
    addressCountryCode: "String!",
    displayName: "String!",
    name: "String!",
    status: "String!",
    cachedUnitAvailableForSale: "Decimal!",
    cachedUnitReserved: "Decimal!",
    cachedUnitSold: "Decimal!",
    cachedUnitTotal: "Decimal!",
    "groups.some.groupUuid": "UUID!",
    areaNetHa: "Decimal!",
    duration: "Decimal!",
    locationGridReference: "String!",
    locationCoordinates: "String!",
    "projectReference.externalReference": "String!",
    responsibleOwnerOrganisationUuid: "UUID!",
  };

  // convenient though expensive deep clone.
  // const reqWithoutOrganisationUuids = cloneDeep(req);
  // if (reqWithoutOrganisationUuids.filter?.results?.standard?.uuid)
  //   reqWithoutOrganisationUuids.filter.results.standard = undefined;
  // // if (reqWithoutOrganisationUuids.filter?.results?.developer?.uuid) {
  // //   reqWithoutOrganisationUuids.filter.results.developer = undefined;
  // // }
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query ( ${variablesBlock}) {
      searchProjects(
        ${queryBlock}
      ) {
        edges {
          node {
            id
            phase
            displayName
            name
            status
            uuid
            addressCountryCode
            cachedUnitSold
            cachedUnitTotal
            cachedUnitAvailableForSale
            cachedUnitReserved
            areaNetHa
            duration
            locationCoordinates
            locationGridReference
            startDate
            projectType {
              displayName
              uuid
            }
            developer {
              displayName
              uuid
            }
            standard {
              displayName
              uuid
            }
            validator {
              displayName
              uuid
            }
            assetManager {
              displayName
            }
            developmentManager {
              displayName
            }
            groups {
              groupUuid
            }
            projectReference {
              externalReference
            }
            responsibleOwnerOrganisationUuid
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjects as SearchResultsGraphQL<SearchProjectsResponse["results"][number]>;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectTracker = async (
  req: SearchProjectTrackerRequest & FilterGroups<SearchProjectTrackerRequest["filter"]>,
  statusFilter?: { operator: string; value: string[] }
): Promise<BaseResponseWithSingle<SearchProjectTrackerResponse>> => {
  const graphqlTypes = {
    "assetManager.displayName": "String!",
    "developer.displayName": "String!",
    "developer.uuid": "UUID!",
    "developmentManager.displayName": "String!",
    "standard.displayName": "String!",
    "standard.uuid": "UUID!",
    "projectType.displayName": "String!",
    "projectType.uuid": "UUID!",
    "validator.displayName": "String",
    "validator.uuid": "UUID",
    uuid: "[UUID]",
    addressCountryCode: "String!",
    displayName: "String!",
    name: "String!",
    status:
      Array.isArray(req.filter?.results?.status?.value) ||
      (req.filterGroups && Array.isArray(req.filterGroups[0].filter?.results?.status?.value))
        ? "[String!]"
        : "String!",
    cachedUnitTotal: "Decimal!",
    cachedUnitSold: "Decimal!",
    cachedUnitAvailableForSale: "Decimal!",
    cachedUnitReserved: "Decimal!",
    cachedPhase: "String",
    areaNetHa: "Decimal",
    startDate: "Date",
    dates: "String",
    implementationDate: "Date",
    registrationDate: "Date",
    validationDate: "Date",
    verificationDate: "Date",
    duration: "Decimal",
    tco2e: "Decimal",
    locationGridReference: "String",
    "projectReference.externalReference": "String",
    "workflow.templateUuid": "UUID",
    "workflow.uuid": "UUID",
    "registryGroup.groupName": "String",
    "registryGroup.type": "String",
    "registryGroup.groupUuid":
      req.filterGroups && Array.isArray((req.filterGroups[0].filter?.results?.registryGroup as any)?.groupUuid?.value)
        ? "[UUID]"
        : "UUID",
    "landholding.groupName": "String",
    "landholding.type": "String",
    "landholding.groupUuid":
      req.filterGroups && Array.isArray((req.filterGroups[0].filter?.results?.landholding as any)?.groupUuid?.value)
        ? "[UUID]"
        : "UUID",
  };

  // eslint-disable-next-line prefer-const
  let [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  if (statusFilter !== undefined && statusFilter.value.length > 0) {
    if (queryBlock.indexOf("status: {") === -1)
      queryBlock = insertAfterSubstring(
        queryBlock,
        "where: {",
        ` status: { ${statusFilter.operator}: ["${statusFilter.value.join('", "')}"] } `
      );
    else
      queryBlock = insertAfterSubstring(
        queryBlock,
        "status: {",
        ` ${statusFilter.operator}: ["${statusFilter.value.join('", "')}"], `
      );
  }

  const QUERY = `
    query ( ${variablesBlock}) {
      searchProjectTracker(
        ${queryBlock}
      ) {
        edges {
          node {
            id
            displayName
            name
            status
            uuid
            rowVersion
            addressCountryCode
            cachedUnitTotal
            cachedUnitSold
            cachedUnitAvailableForSale
            cachedUnitReserved
            areaNetHa
            dates
            duration
            tco2e
            locationGridReference
            startDate
            implementationDate
            registrationDate
            validationDate
            verificationDate
            cachedPhase
            projectListingScore
            projectType {
              displayName
              uuid
            }
            developer {
              displayName
              uuid
            }
            standard {
              displayName
              uuid
            }
            standardSpecificSchemaUuid
            validator {
              displayName
              uuid
            }
            assetManager {
              displayName
            }
            developmentManager {
              displayName
            }
            registryGroup {
              groupUuid
              groupName
              type
            }
            landholding {
              groupUuid
              groupName
              type
            }
            projectReference {
              externalReference
            }
            workflow {
              nextMilestone {
                deadline
                name
              }
              templateUuid
              uuid
            }
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectTracker as SearchResultsGraphQL<
        SearchProjectTrackerResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchStandards = async (
  req: SearchStandardsRequest
): Promise<BaseResponseWithSingle<SearchStandardsResponse>> => {
  const graphqlTypes = {
    displayName: "String!",
    description: "String",
    uuid: "UUID!",
    "parentOrganisation.displayName": "String!",
    "projectTypes.some.standardSpecificSchemaId": "Int",
    "projectTypes.some.displayName": "String!",
    "projectTypes.some.uuid": "UUID!",
    canCreateNewProjects: "Boolean!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  const QUERY = gql`
    query (${variablesBlock}) {
      searchStandards(
        ${queryBlock}
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            id
            uuid
            displayName
            canCreateNewProjects
            parentOrganisation {
              displayName
              uuid
            }
            projectTypes{
              uuid
              displayName
              standardSpecificSchemaId
              dateSchema
            }
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      const data = response.data.searchStandards as SearchResultsGraphQL<SearchStandardsResponse["results"][number]>;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};
interface GetProjectDetailsResponseGraphQL {
  projectDetails: GetProjectDetailsResponse[];
}

export const getProjectDetails = async (
  req: GetProjectDetailsRequest
): Promise<BaseResponseWithSingle<GetProjectDetailsResponse>> => {
  const QUERY = gql`
    query ($projectUuid: UUID, $projectExternalReference: String, $projectType: String) {
      projectDetails(
        request: {
          projectUuid: $projectUuid
          projectExternalReference: $projectExternalReference
          projectType: $projectType
        }
      ) {
        uuid
        name
        displayName
        addressCity
        addressCountryCode
        addressRegion
        addressLine1
        dataScore
        areaNetHa
        status
        cachedAvailableQuantity
        cachedSoldQuantity
        cachedReservedQuantity
        cachedTotalQuantity
        cachedPhase
        calculatedAreaHabitatQuantity
        calculatedHedgerowQuantity
        calculatedWatercourseQuantity
        dates
        locationCoordinates
        locationGridReference
        unitMeasurements
        rowVersion
        currentUserPermissions
        developer {
          displayName
          uuid
          files {
            file {
              url
            }
            type
          }
          listing {
            content
          }
        }
        standard {
          displayName
          uuid
          files {
            file {
              url
            }
          }
        }
        standardSpecificData
        validator {
          displayName
          uuid
          files {
            file {
              url
            }
          }
        }
        responsibleOwner {
          uuid
          displayName
          organisationType
          rowVersion
        }
        group {
          groupName
          groupUuid
        }
        landholding {
          groupName
          groupUuid
        }
        listing {
          availableForSale
          contactAlternativeEmail
          contactOptOut
          content
          hidden
          rowVersion
          showPriceInDirectory
          seekingFunding
          pilotProject
        }
        listingFiles {
          uuid
          file {
            filename
            url
            mimeType
          }
        }
        badges {
          uuid
          displayName
          files {
            file {
              url
            }
            type
          }
          type
        }
        projectType {
          displayName
          uuid
        }
        projectReference {
          externalReference
          externalParty
        }
        standardSpecificSchemaUuid
        projectLocation {
          uuid
          rowVersion
          boundaryData
          locationFileUrl
        }
        workflowUuid
        privateStandardSpecificData
      }
    }
  `;
  return apolloPrivate
    .query<GetProjectDetailsResponseGraphQL>({
      query: QUERY,
      variables: {
        projectUuid: req.projectUuid,
        projectExternalReference: req.projectExternalReference,
        projectType: req.projectType,
      },
    })
    .then((response) => {
      if (
        response.data.projectDetails[0].listing?.content &&
        typeof response.data.projectDetails[0].listing?.content === "string"
      )
        response.data.projectDetails[0].listing.content = JSON.parse(
          response.data.projectDetails[0].listing.content,
          jsonReviver
        );
      if (
        response.data.projectDetails[0].standardSpecificData &&
        typeof response.data.projectDetails[0].standardSpecificData === "string"
      )
        response.data.projectDetails[0].standardSpecificData = JSON.parse(
          response.data.projectDetails[0].standardSpecificData,
          jsonReviver
        );
      if (
        response.data.projectDetails[0].privateStandardSpecificData &&
        typeof response.data.projectDetails[0].privateStandardSpecificData === "string"
      )
        response.data.projectDetails[0].privateStandardSpecificData = JSON.parse(
          response.data.projectDetails[0].privateStandardSpecificData,
          jsonReviver
        );
      if (
        response.data.projectDetails[0].developer?.listing?.content &&
        typeof response.data.projectDetails[0].developer?.listing?.content === "string"
      ) {
        response.data.projectDetails[0].developer.listing.content = JSON.parse(
          response.data.projectDetails[0].developer?.listing?.content,
          jsonReviver
        );
      }

      // TODO KAN-4532 remove this after BE FIX
      if (response.data.projectDetails[0].addressRegion) {
        response.data.projectDetails[0].addressRegion = response.data.projectDetails[0].addressRegion.replaceAll(
          "�",
          "ô"
        );
      }
      return {
        status: Status.Success,
        data: response.data.projectDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getProjectIssuances = async (
  req: GetProjectIssuancesRequest
): Promise<BaseResponseWithSingle<GetProjectIssuancesResponse>> => {
  const graphqlTypes = {
    createdOrEnhanced: "String",
    designatedSite: "String",
    distinctiveness: "String",
    eligibility: "String",
    habitat: "String",
    habitatType: "String",
    lnrs: "String",
    lpa: "String",
    nca: "String",
    serialNumber: "String",
    unitQuantityAvailable: "Decimal!",
    unitQuantityTotal: "Decimal!",
    unitQuantitySold: "Decimal!",
    unitQuantityReserved: "Decimal!",
    quotedUnits: "Decimal!",
    areaHaRemaining: "Decimal",
    quantityType: "String",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    status: Array.isArray((req.filter?.results as any)?.status?.value) ? "[String]" : "String",
    verificationStatus: "String",
    unitHa: "Decimal",
    unitKm: "Decimal",
    percentageSold: "Decimal",
    price: "Decimal",
    unitMeasurement: "String",
    yearsEligible: "Int",
    uuid: Array.isArray(req.filter?.results?.uuid?.value) ? "[UUID]" : "UUID",
    "verifier.uuid": "UUID",
    "verifier.displayName": "String",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = gql`
    query ($projectUuid: UUID!, $groupUuid: UUID, ${variablesBlock}) {
      projectIssuances(
      request: {projectUuid: $projectUuid, groupUuid: $groupUuid}
        ${queryBlock}
        ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            areaHaRemaining
            createdOrEnhanced
            designatedSite
            distinctiveness
            eligibility
            habitat
            habitatType
            lpa
            nca
            lnrs
            uuid
            rowVersion
            percentageSold
            price
            issuanceDate
            quantityType
            status
            serialNumber
            standardSpecificIssuanceData
            unitMeasurement
            unitQuantityAvailable
            unitQuantityReserved
            unitQuantitySold
            unitQuantityTotal
            quotedUnits
            updatedAt
            verifier {
              uuid
              displayName
            }
            vintageStartDate
            vintageEndDate
            yearsEligible
            unitHa
            unitKm
            verificationStatus
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables: { ...variables, projectUuid: req.request.projectUuid, groupUuid: req.request.groupUuid },
    })
    .then((response) => {
      const data = response.data.projectIssuances as SearchResultsGraphQL<
        GetProjectIssuancesResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getAggregateIssuances = async (
  req: GetAggregateIssuancesRequest & FilterGroups<SearchActivitiesRequest["filter"]>
): Promise<BaseResponseWithSingle<GetAggregateIssuancesResponse>> => {
  const graphqlTypes = {
    availableUnits: "Decimal",
    averagePrice: "Decimal",
    totalValue: "Decimal",
    percentageSold: "Decimal",
    quotedUnits: "Decimal",
    reservedUnits: "Decimal",
    soldUnits: "Decimal",
    areaHa: "Decimal",
    landholdingUuid: "UUID",
    landholdingName: "String",
    verifierName: "String",
    unitKm: "Decimal",
    groupByFieldContent1: "String",
    groupByFieldContent2: Array.isArray(req.filter?.results?.groupByFieldContent2?.value) ? "[String]" : "String",
    groupByFieldContent3: "String",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = gql`
    query (${variablesBlock}, $groupBy: [String!], $filters: [GetAggregateIssuancesRequestFilterInput!], $isReadableProject: Boolean!) {
      aggregateIssuances(request: { groupBy: $groupBy, filters: $filters, isReadableProject: $isReadableProject } ${queryBlock}) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            availableUnits
            averagePrice
            totalValue
            percentageSold
            quotedUnits
            reservedUnits
            soldUnits
            areaHa
            landholdingUuid
            landholdingName
            verifierName
            unitKm
            groupByFieldContent1
            groupByFieldContent2
            groupByFieldContent3
          }
        }
        aspects {
          measurementTypes
          totalAvailableUnits
          totalReservedUnits
          totalSoldUnits
          tags {
            tagData
            tagUuid
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables: {
        ...variables,
        ...{
          filters: req.filters,
          groupBy: req.groupBy,
          isReadableProject: req.isReadableProject,
        },
      },
    })
    .then((response) => {
      const data = response.data.aggregateIssuances as SearchResultsGraphQL<
        GetAggregateIssuancesResponse["results"][number]
      >;
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          aspects: response.data.aggregateIssuances.aspects as GetAggregateIssuancesResponse["aspects"],
          results: data.edges.map((e) => e.node),
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchOrganisationUsers = async (
  req: SearchOrganisationUsersRequest
): Promise<BaseResponseWithSingle<SearchOrganisationUsersResponse>> => {
  const graphqlTypes = {
    role: "String!",
    active: "Boolean!",
    "user.email": "String!",
    "user.uuid": "UUID!",
    "user.firstName": "String!",
    "user.lastName": "String!",
    "user.fullName": "String!",
    "user.avatar.url": "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.organisationUuid = req.organisationUuid;
  const QUERY = `
    query ($organisationUuid: UUID!, ${variablesBlock}) {
      searchOrganisationUsers(
        organisationUuid: $organisationUuid
        ${queryBlock}
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            role
            active
            user {
              uuid
              firstName
              lastName
              fullName
              email
              avatar {
                url
              }
            }
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchOrganisationUsers as SearchResultsGraphQL<
        SearchOrganisationUsersResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchCollaborators = async (
  req: SearchCollaboratorsRequest
): Promise<BaseResponseWithSingle<SearchCollaboratorsResponse>> => {
  const graphqlTypes = {
    name: "String!",
    uuid: "UUID",
    collaboratorType: Array.isArray(req.filter?.results?.collaboratorType?.value) ? "[String]" : "String!",
    email: "String",
    phone: "String",
    addressCountryCode: "String",
    addressRegion: "String",
    externalParty: "String",
    externalReference: "String",
    "associatedProjects.groups.groupName": "String",
    "associatedProjects.groups.groupUuid": "UUID",
    "associatedProjects.groups.type": "String",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  const QUERY = `
    query (${variablesBlock}) {
      searchCollaborators(
        ${queryBlock}
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            addressCity
            addressCountryCode
            addressLine1
            addressLine2
            addressPostcode
            addressRegion
            collaboratorType
            description
            email
            externalParty
            externalReference
            name
            organisationUuid
            phone
            rowVersion
            uuid
            website
            organisationUuid
            associatedProjects {
              areaHa
              developerDisplayName
              displayName
              locationCoordinates
              phase
              projectTypeDisplayName
              region
              role
              standardDisplayName
              uuid
              verifierDisplayName
              unitQuantityAvailable
              groups {
                groupName
                groupUuid
                type
              }
            }
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchCollaborators as SearchResultsGraphQL<
        SearchCollaboratorsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

/*
  Documents linked to an object (today only a workflow or general task — KAN-9501). The connection is
  ACL-gated server-side: documents the user cannot read are omitted rather than erroring, so an empty
  list is a valid answer. `uuid`/`rowVersion` identify the link itself and are what deleteObjectDocument
  needs, so they are always selected.
*/
export const getObjectDocuments = async (
  req: GetObjectDocumentsRequest
): Promise<BaseResponseWithSingle<GetObjectDocumentsResponse>> => {
  const variables = { objectUuid: req.objectUuid, objectType: req.objectType };

  const QUERY = `
    query ($objectUuid: UUID!, $objectType: String!) {
      objectDocuments(request: { objectUuid: $objectUuid, objectType: $objectType }, first: 50) {
        totalCount
        nodes {
          uuid
          rowVersion
          documentUuid
          documentSource
          documentType
          variant
          fileName
          url
          uploadedByUserUuid
          uploadedAt
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: {
          results: response.data.objectDocuments?.nodes ?? [],
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export interface GetOrganisationDetailsResponseGraphQL {
  organisationDetails: GetOrganisationDetailsResponse[];
}

export const getOrganisationDetails = async (
  req: GetOrganisationDetailsRequest
): Promise<BaseResponseWithSingle<GetOrganisationDetailsResponse>> => {
  const QUERY = gql`
    query ($organisationUuid: UUID!) {
      organisationDetails(organisationUuid: $organisationUuid) {
        displayName
        rowVersion
        addresses {
          city
          countryCode
          line1
          line2
          region
          postcode
          type
          rowVersion
        }
      }
    }
  `;
  return apolloPrivate
    .query<GetOrganisationDetailsResponseGraphQL>({
      query: QUERY,
      variables: { organisationUuid: req.organisationUuid },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.organisationDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

const getOrganisationDetailsHelper = (type: OrganisationType): DocumentNode => {
  let queryType = "";
  switch (type) {
    case OrganisationType.Developer:
      queryType = `query ($developerUuid: UUID!) {
        developerDetails(developerUuid: $developerUuid) {`;
      break;
    case OrganisationType.Standard:
      queryType = `query ($standardUuid: UUID!) {
        standardDetails(standardUuid: $standardUuid) {`;
      break;
    case OrganisationType.Verifier:
      queryType = `query ($verifierUuid: UUID!) {
        verifierDetails(verifierUuid: $verifierUuid) {`;
      break;
    case OrganisationType.Badge:
      queryType = `query ($badgeUuid: UUID!) {
        badgeDetails(badgeUuid: $badgeUuid) {`;
      break;
    case OrganisationType.DevelopmentManager:
      queryType = `query ($developmentManagerUuid: UUID!) {
        developmentManagerDetails(developmentManagerUuid: $developmentManagerUuid) {`;
      break;
    case OrganisationType.AssetManager:
      queryType = `query ($assetManagerUuid: UUID!) {
        assetManagerDetails(assetManagerUuid: $assetManagerUuid) {`;
      break;
    default:
      break;
  }
  return gql`
    ${queryType}
        uuid
        websiteUrl
        rowVersion
        contactEmail
        contactPhone
        displayName
        socialMediaFacebookUrl
        socialMediaInstagramUsername
        socialMediaLinkedInUrl
        socialMediaTwitterUsername
        socialMediaYoutubeChannel
        files {
          type
          file {
            url
          }
        }
        listing {
          content
          rowVersion
        }
         ${
           type !== OrganisationType.AssetManager
             ? `
         listingFiles {
          uuid
          file {
            url
          }
        }`
             : ""
         }
        ${
          type === OrganisationType.Standard
            ? `
        canCreateNewProjects
        standardSpecificDataSchema {
          name
          latestVersion
        }`
            : ""
        }
      }
    }
  `;
};

interface GetDeveloperDetailsResponseGraphQL {
  developerDetails: GetDeveloperDetailsResponse[];
}

export const getDeveloperDetails = async (
  req: GetDeveloperDetailsRequest
): Promise<BaseResponseWithSingle<GetDeveloperDetailsResponse>> => {
  const QUERY = getOrganisationDetailsHelper(OrganisationType.Developer);

  return apolloPrivate
    .query<GetDeveloperDetailsResponseGraphQL>({
      query: QUERY,
      variables: { developerUuid: req.developerUuid },
    })
    .then((response) => {
      if (response.data.developerDetails[0].listing?.content)
        response.data.developerDetails[0].listing.content = JSON.parse(
          response.data.developerDetails[0].listing.content,
          jsonReviver
        );
      return {
        status: Status.Success,
        data: response.data.developerDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetStandardDetailsResponseGraphQL {
  standardDetails: GetStandardDetailsResponse[];
}

export const getStandardDetails = async (
  req: GetStandardDetailsRequest
): Promise<BaseResponseWithSingle<GetStandardDetailsResponse>> => {
  const QUERY = getOrganisationDetailsHelper(OrganisationType.Standard);

  return apolloPrivate
    .query<GetStandardDetailsResponseGraphQL>({
      query: QUERY,
      variables: { standardUuid: req.standardUuid },
    })
    .then((response) => {
      if (response.data.standardDetails[0].listing?.content)
        response.data.standardDetails[0].listing.content = JSON.parse(
          response.data.standardDetails[0].listing.content,
          jsonReviver
        );
      return {
        status: Status.Success,
        data: response.data.standardDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetVerifierDetailsResponseGraphQL {
  verifierDetails: GetVerifierDetailsResponse[];
}

export const getVerifierDetails = async (
  req: GetVerifierDetailsRequest
): Promise<BaseResponseWithSingle<GetVerifierDetailsResponse>> => {
  const QUERY = getOrganisationDetailsHelper(OrganisationType.Verifier);

  return apolloPrivate
    .query<GetVerifierDetailsResponseGraphQL>({
      query: QUERY,
      variables: { verifierUuid: req.verifierUuid },
    })
    .then((response) => {
      if (response.data.verifierDetails[0].listing?.content)
        response.data.verifierDetails[0].listing.content = JSON.parse(
          response.data.verifierDetails[0].listing.content,
          jsonReviver
        );
      return {
        status: Status.Success,
        data: response.data.verifierDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getOrganisationEmbeddingPreferences = async (
  req: GetOrganisationEmbeddingPreferencesRequest
): Promise<BaseResponseWithMultiple<GetOrganisationEmbeddingPreferencesResponse>> => {
  throw new Error(`Not implemented yet server-side ${req.organisationUuid}`);
};

interface GetOrganisationUserDetailsResponseGraphQL {
  organisationUserDetails: GetOrganisationUserDetailsResponse[];
}
export const getOrganisationUserDetails = async (
  req: GetOrganisationUserDetailsRequest
): Promise<BaseResponseWithSingle<GetOrganisationUserDetailsResponse>> => {
  const QUERY = gql`
    query ($userUuid: UUID!) {
      organisationUserDetails(userUuid: $userUuid) {
        role
        active
        rowVersion
        user {
          firstName
          lastName
          fullName
          email
          avatar {
            url
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<GetOrganisationUserDetailsResponseGraphQL>({
      query: QUERY,
      variables: { userUuid: req.userUuid },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.organisationUserDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetProjectAggregateResponseGraphQL {
  projectAggregate: GetProjectAggregateResponse[];
}

export const getProjectAggregate = async (
  req: GetProjectAggregateRequest
): Promise<BaseResponseWithMultiple<GetProjectAggregateResponse>> => {
  const QUERY = gql`
    query (
      $filterBy: String
      $filterOperator: String
      $filterValue: String
      $groupBy: String
      $aggregate: String
      $aggregation: String
    ) {
      projectAggregate(
        request: {
          filterBy: $filterBy
          filterOperator: $filterOperator
          filterValue: $filterValue
          groupBy: $groupBy
          aggregate: $aggregate
          aggregation: $aggregation
        }
      ) {
        key
        value
      }
    }
  `;
  return apolloPrivate
    .query<GetProjectAggregateResponseGraphQL>({
      query: QUERY,
      variables: {
        filterBy: req.filterBy,
        filterOperator: req.filterOperator,
        filterValue: req.filterValue,
        groupBy: req.groupBy,
        aggregate: req.aggregate,
        aggregation: req.aggregation,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.projectAggregate,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetCurrentUserResponseGraphQL {
  currentUser: GetCurrentUserResponse[];
}

export const getCurrentUser = async (): Promise<BaseResponseWithSingle<GetCurrentUserResponse>> => {
  const QUERY = gql`
    query {
      currentUser {
        userUuid
        firstName
        lastName
        fullName
        email
        rowVersion
        avatar {
          url
          uuid
        }
        organisations {
          termsAccepted
          role
          assetManagerUuid
          organisationUuid
          developerUuid
          developmentManagerUuid
          standardUuid
          verifierUuid
          permissions
          termsAccepted
        }
      }
    }
  `;
  return apolloPrivate
    .query<GetCurrentUserResponseGraphQL>({
      query: QUERY,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.currentUser[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface LookUpResponseGraphQL {
  lookUp: LookUpResponse[];
}

export const lookUp = async (req: LookUpRequest): Promise<BaseResponseWithMultiple<LookUpResponse>> => {
  const graphqlTypes = {
    type: "String!",
  };
  const [queryBlock] = generateGraphQLHelpers(req, graphqlTypes, false);
  const QUERY = gql`
    query ($type: String!) {
      lookUp(
        request: { type: $type }
        ${queryBlock}) {
        key
        valueString
      }
    }
  `;
  return apolloPrivate
    .query<LookUpResponseGraphQL>({
      query: QUERY,
      variables: {
        type: req.type,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.lookUp,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export interface GetStatsAggregateResponseGraphQL {
  statsAggregate: GetStatsAggregateResponse[];
}

export const getStatsAggregate = async (
  req: GetStatsAggregateRequest
): Promise<BaseResponseWithMultiple<GetStatsAggregateResponse>> => {
  const QUERY = gql`
    query ($metric: String, $objectType: String, $objectUuid: UUID, $periodicity: String) {
      statsAggregate(
        request: { metric: $metric, objectType: $objectType, objectUuid: $objectUuid, periodicity: $periodicity }
      ) {
        objectName
        objectUuid
        value
      }
    }
  `;

  return apolloPrivate
    .query<GetStatsAggregateResponseGraphQL>({
      query: QUERY,
      variables: {
        metric: req.metric,
        objectType: req.objectType,
        objectUuid: req.objectUuid,
        periodicity: req.periodicity,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.statsAggregate,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchVerifiers = async (
  req: SearchVerifiersRequest
): Promise<BaseResponseWithSingle<SearchVerifiersResponse>> => {
  const graphqlTypes = {
    displayName: "[String!]",
    uuid: "[UUID!]",
    supportsDigitalVerification: "Boolean!",
    "projectTypes.some.uuid": "UUID!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  const QUERY = gql`
    query (${variablesBlock}) {
      searchVerifiers(${queryBlock}) {
        edges {
          cursor
          node {
            id
            displayName
            uuid
            parentOrganisation {
              uuid
              displayName
            }
            supportsDigitalVerification
                files {
                    file {
                        url
                    }
                    type
                }
            projectTypes {
                uuid
                displayName
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      const data = response.data.searchVerifiers as SearchResultsGraphQL<SearchVerifiersResponse["results"][number]>;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const SearchProjectOrganisationInvitations = async (
  req: SearchProjectOrganisationInvitationsRequest & FilterGroups<SearchProjectOrganisationInvitationsRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchProjectOrganisationInvitationsResponse>> => {
  const graphqlTypes = {
    sentDate: "Date!",
    role: "String!",
    type: "String",
    calculatedStatus: "String!",
    "project.displayName": "String!",
    "project.uuid": "UUID!",
    "sentByUser.fullName": "String!",
    "sentByUser.firstName": "String!",
    "sentByUser.lastName": "String!",
    "sourceOrganisation.displayName": "String!",
    "sourceOrganisation.uuid": "UUID!",
    "targetOrganisation.displayName": "String!",
    "targetOrganisation.uuid": "UUID!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  // TODO add inviationUuid here after BE PR is complete
  // https://github.com/kana-earth/api/pull/274#pullrequestreview-1206224730
  const QUERY = `
    query(${variablesBlock}) {
      searchProjectOrganisationInvitations(
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            targetOrganisation {
              uuid
              displayName
            }
            sourceOrganisation {
              uuid
              displayName
            }
            project {
              uuid
              displayName
            }
            sentByUser {
              firstName
              lastName
              fullName
              uuid
            }
            sentDate
            role
            organisationType
            sourceOrganisationType
            uuid
            calculatedStatus
            type
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectOrganisationInvitations as SearchResultsGraphQL<
        SearchProjectOrganisationInvitationsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

interface GetProjectOrganisationInvitationDetailsResponseGraphQL {
  projectOrganisationInvitationDetails: GetProjectOrganisationInvitationDetailsResponse[];
}

export const getProjectOrganisationInvitationDetails = async (
  req: GetProjectOrganisationInvitationDetailsRequest
): Promise<BaseResponseWithSingle<GetProjectOrganisationInvitationDetailsResponse>> => {
  const QUERY = gql`
    query ($projectOrganisationInvitationUuid: UUID!) {
      projectOrganisationInvitationDetails(invitationUuid: $projectOrganisationInvitationUuid) {
        targetOrganisation {
          uuid
          displayName
          contactEmail
          contactPhone
          organisationType
        }
        sourceOrganisation {
          uuid
          displayName
          contactEmail
          contactPhone
        }
        sentDate
        calculatedStatus
        project {
          uuid
          displayName
          status
          standard {
            uuid
            displayName
          }
        }
        role
        makeResponsibleOwner
        acceptedDate
        rejectedDate
        expiresDate
        revoked
        sentByUser {
          firstName
          lastName
          fullName
          uuid
        }
        acceptedByUser {
          firstName
          lastName
          fullName
          uuid
        }
        rejectedByUser {
          firstName
          lastName
          fullName
          uuid
        }
        revokedByUser {
          firstName
          lastName
          fullName
          uuid
        }
        rowVersion
        type
      }
    }
  `;

  return apolloPrivate
    .query<GetProjectOrganisationInvitationDetailsResponseGraphQL>({
      query: QUERY,
      variables: { projectOrganisationInvitationUuid: req.projectOrganisationInvitationUuid },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.projectOrganisationInvitationDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchDevelopers = async (
  req: SearchDevelopersRequest
): Promise<BaseResponseWithSingle<SearchDevelopersResponse>> => {
  const graphqlTypes = {
    excludedProjectUuid: "UUID",
    displayName: "String!",
    uuid: "UUID!",
    "parentOrganisation.uuid": "UUID!",
    "parentOrganisation.displayName": "String!",
    "parentOrganisation.hasUsers": "Boolean!",
    searchDevelopers: "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query($excludedProjectUuid: UUID, ${variablesBlock}) {
      searchDevelopers(
        request: {excludedProjectUuid: $excludedProjectUuid}, ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            displayName
            uuid
            parentOrganisation {
              uuid
              displayName
              hasUsers
            }
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        ...variables,
        excludedProjectUuid: req.excludedProjectUuid,
      },
    })
    .then((response) => {
      const data = response.data.searchDevelopers as SearchResultsGraphQL<SearchDevelopersResponse["results"][number]>;

      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchOrganisations = async (
  req: SearchOrganisationsRequest
): Promise<BaseResponseWithSingle<SearchOrganisationsResponse>> => {
  const graphqlTypes = {
    accessInviteOptOut: "Boolean!",
    displayName: "String!",
    organisationUuid: "UUID!",
  };
  /*
    Ordering is left off: SearchOrganisationsResultSortInput has no id field, so the shared default
    order (id ASC) would be rejected outright. The resolver already orders by displayName.
  */
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = `
    query($organisationType: OrganisationType!, $excludedProjectUuid: UUID, ${variablesBlock}) {
      searchOrganisations(
        organisationType: $organisationType, excludedProjectUuid: $excludedProjectUuid, ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            organisationUuid
            displayName
            organisationType
            subOrganisationUuid
            accessInviteOptOut
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        ...variables,
        organisationType: req.organisationType,
        excludedProjectUuid: req.excludedProjectUuid,
      },
    })
    .then((response) => {
      const data = response.data.searchOrganisations as SearchResultsGraphQL<
        SearchOrganisationsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchActivities = async (
  req: SearchActivitiesRequest & FilterGroups<SearchActivitiesRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchActivitiesResponse>> => {
  const graphqlTypes = {
    "project.uuid": "UUID",
    "group.uuid": "UUID!",
    "project.displayName": "String!",
    "group.displayName": "String!",
    createdAt: "Date!",
    status: "[String!]",
    "_0_.status": "String!",
    "_1_.status": "String!",
    "_2_.status": "String!",
    "_3_.status": "String!",
    "_4_.status": "String!",
    "_5_.status": "String!",
    "_6_.status": "String!",
    "_7_.status": "String!",
    "_8_.status": "String!",
    // eslint-disable-next-line prettier/prettier
    isUnderReview: "Boolean!",
    variant: "String!",
    uuid: "UUID!",
    "project.standard.displayName": "String",
    "project.verifier.displayName": "String",
    "project.developer.displayName": "String",
    "activityDefinition.displayName": "String!",
    "currentVersion.createdByUser.fullName": "String!",
    "currentVersion.createdAt": "Date!",
    "currentVersion.updatedAt": "Date!",
    "currentVersion.updatedByUser.fullName": "String!",
    "currentVersion.versionNumber": "Decimal!",
    "latestVersion.updatedAt": "Date!",
    "latestVersion.updatedByUser.fullName": "String!",
    "latestVersion.versionNumber": "Decimal!",
    "latestVersion.completionPercentage": "Decimal!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query(${variablesBlock}) {
      searchActivities(
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            firstSubmissionDate
            activityDefinition {
              displayName
              uuid
            }
            completionDate
            createdAt
            createdByUser {
              fullName
              firstName
              lastName
            }
            firstSubmissionDate
            isUnderReview
            latestVersion {
                updatedAt
                updatedByUser {
                  fullName
                  firstName
                  lastName
                }
                versionNumber
                completionPercentage
            }
            reviewVersion {
                rowVersion
                submittedAt
                uuid
                createdAt
                createdByUser {
                    firstName
                    fullName
                    lastName
                }
                updatedAt
                updatedByUser {
                  fullName
                  firstName
                  lastName
                }
                versionNumber
            }
            currentVersion {
              activityDefinitionVersion {
                isManuallyApproved
              }
              completionPercentage
              createdAt
              updatedAt
              createdByUser {
                fullName
                firstName
                lastName
              }
              updatedByUser {
                fullName
                firstName
                lastName
              }
              uuid
              versionNumber
            }
            draftVersion {
              activityDefinitionVersion {
                isManuallyApproved
              }
              completionPercentage
              createdAt
              createdByUser {
                fullName
                firstName
                lastName
              }
              updatedAt
              updatedByUser {
                fullName
                firstName
                lastName
              }
              previousActivityHistoryUuid
              uuid
              versionNumber
              rowVersion
            }
            project {
              displayName
              standard {
                displayName
                uuid
              }
              developer {
                displayName
              }
              uuid
              verifier {
                displayName
                uuid
                supportsDigitalVerification
              }
            }
            group {
              displayName
              externalReference
              uuid
              standard {
                displayName
                uuid
              }
              developer {
                displayName
                uuid
              }
              verifier {
                displayName
                uuid
                supportsDigitalVerification
              }
            }
            rowVersion
            status
            uuid
            variant
          }
        }
      }
    }`;
  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchActivities as SearchResultsGraphQL<SearchActivitiesResponse["results"][number]>;

      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchActivityReviews = async (
  req: SearchActivityReviewsRequest
): Promise<BaseResponseWithSingle<SearchActivityReviewsResponse>> => {
  const graphqlTypes = {
    "project.uuid": "UUID",
    "project.displayName": "String",
    "group.uuid": "UUID",
    "developer.displayName": "String!",
    "standard.displayName": "String!",
    "assignedToUser.uuid": "UUID",
    "assignedToUser.fullName": "String",
    "activity.uuid": "UUID!",
    "activity.status": "String!",
    "activity.variant": "String!",
    "activity.activityDefinition.displayName": "String!",
    completionPercentage: "Decimal!",
    status: "String!",
    type: "String",
    calculatedDaysInQueue: "Decimal!",
    calculatedDaysToDeadline: "Decimal!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
      query(${variablesBlock}) {
        searchActivityReviews(${queryBlock})
        {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
            edges {
                node {
                    id
                    activity {
                        activityDefinition {
                            displayName
                            uuid
                        }
                        currentVersion {
                            activityDefinitionVersion {
                                isManuallyApproved
                            }
                            completionPercentage
                            createdAt
                            createdByUser {
                                firstName
                                fullName
                                lastName
                            }
                            uuid
                            versionNumber
                            isUnderReview
                        }
                        rowVersion
                        status
                        uuid
                        variant
                    }
                    activityReviewUuid
                    assignedToUser {
                        fullName
                        uuid
                    }
                    primaryAssignedToUser {
                        fullName
                        uuid
                    }
                    calculatedDaysInQueue
                    calculatedDaysToDeadline
                    completionPercentage
                    developer {
                        displayName
                        uuid
                    }
                    group {
                        displayName
                        externalReference
                        uuid
                    }
                    project {
                        displayName
                        uuid
                    }
                    rowVersion
                    standard {
                        displayName
                        uuid
                    }
                    status
                    type
                }
            }
        }
    }`;
  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchActivityReviews as SearchResultsGraphQL<
        SearchActivityReviewsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

interface GetActivityReviewDetailsResponseGraphQL {
  activityReviewDetails: GetActivityReviewDetailsResponse[];
}

export const getActivityReviewDetails = async (
  req: GetActivityReviewDetailsRequest
): Promise<BaseResponseWithSingle<GetActivityReviewDetailsResponse>> => {
  const graphqlTypes = {
    "activityHistoryDetailsResponse.project.uuid": "UUID!",
    "activityHistoryDetailsResponse.project.displayName": "String!",
    "activityHistoryDetailsResponse.createdAt": "Date!",
    "activityHistoryDetailsResponse.status": "String!",
    "activityHistoryDetailsResponse.variant": "String!",
    "activityHistoryDetailsResponse.activityDefinition.displayName": "String!",
    "activityHistoryDetailsResponse.currentVersion.createdByUser.fullName": "String!",
    "activityHistoryDetailsResponse.currentVersion.createdAt": "Date!",
    "activityHistoryDetailsResponse.currentVersion.versionNumber": "String!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.activityReviewUuid = req.activityReviewUuid;
  const QUERY = `
    query($activityReviewUuid: UUID!, ${variablesBlock}) {
      activityReviewDetails(request: { activityReviewUuid: $activityReviewUuid ${queryBlock}})
        {
            activityHistoryDetailsResponse {
                uuid
                versionNumber
                changeSummary
                completionPercentage
                createdAt
                data
                isCurrent
                isDraft
                rowVersion
                previousActivityHistoryUuid
                createdByUser {
                    fullName
                    firstName
                    lastName
                    avatar {
                        url
                    }
                }
                documents {
                    activityDefinitionDocumentType {
                        displayName
                        uuid
                    }
                    activityDocumentHistory {
                            file {
                            filename
                            mimeType
                            }
                        uuid
                        variant
                        versionNumber
                    }
                    uuid
                }
                activity {
                    uuid
                    status
                    rowVersion
                    variant
                    group {
                        displayName
                        externalReference
                        uuid
                    }
                    project {
                        displayName
                        uuid
                    }
                    activityDefinition {
                        displayName
                        uuid
                    }
                    activityDefinitionVersion {
                        uuid
                        versionNumber
                    }
                }
            }
            activityReviewUuid
            activityReviewType
            activityReviewStatus
            completionPercentage
            isUnderReview
            rowVersion
            deadline
            assignedToUserUuids
        }
    }`;

  return apolloPrivate
    .query<GetActivityReviewDetailsResponseGraphQL>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: {
          ...response.data.activityReviewDetails[0],
          activityHistoryDetailsResponse: {
            ...response.data.activityReviewDetails[0].activityHistoryDetailsResponse,
            data: JSON.parse(response.data.activityReviewDetails[0].activityHistoryDetailsResponse.data, jsonReviver),
          },
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getActivityReviewAggregate = async (
  req: GetActivityReviewAggregateRequest
): Promise<BaseResponseWithSingle<GetActivityReviewAggregateResponse>> => {
  const QUERY = `
      query($activityUuid: UUID, $activityReviewUuid:UUID, $assignedToUserUuid: UUID ){
        activityReviewAggregate(request: {activityUuid: $activityUuid, activityReviewUuid: $activityReviewUuid, assignedToUserUuid: $assignedToUserUuid }) {
            activityReviewUuid
            approvedDocuments
            resolvedDiscussions
            unapprovedDocuments
            unresolvedDiscussionsOrganisation
            unresolvedDiscussionsAuthor
            assessment
            {
                nearDeadLines
                pastDeadLines
                queued
            }
            review
            {
                nearDeadLines
                pastDeadLines
                queued
            }
        }
      }`;
  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        activityUuid: req.activityUuid ?? null,
        activityReviewUuid: req.activityReviewUuid ?? null,
        assignedToUserUuid: req.assignedToUserUuid ?? null,
      },
    })
    .then((response) => {
      const data = response.data.activityReviewAggregate[0];
      return {
        status: Status.Success,
        data,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchActivityDefinitions = async (
  req: SearchActivityDefinitionsRequest
): Promise<BaseResponseWithSingle<SearchActivityDefinitionsResponse>> => {
  const QUERY = `
    query ($standardUuid: UUID!, $applicableProjectStatus: String!, $applicableActivityDefinitionType: String!) {
      searchActivityDefinitions( request: {standardUuid: $standardUuid, applicableProjectStatus: $applicableProjectStatus, applicableActivityDefinitionType: $applicableActivityDefinitionType}) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            activeVersions {
              uuid
              versionNumber
            }
            applicableProjectStatuses
            applicableActivityDefinitionType
            displayName
            hasVariant
            standard {
              displayName
              uuid
            }
            uuid
          }
        }
      }
    }`;
  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        standardUuid: req.standardUuid,
        applicableProjectStatus: req.applicableProjectStatus[0],
        applicableActivityDefinitionType: req.applicableActivityDefinitionType,
      },
    })
    .then((response) => {
      const data = response.data.searchActivityDefinitions as SearchResultsGraphQL<
        SearchActivityDefinitionsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchActivityHistory = async (
  req: SearchActivityHistoryRequest
): Promise<BaseResponseWithSingle<SearchActivityHistoryResponse>> => {
  const graphqlTypes = {
    isCurrent: "Boolean!",
    isDraft: "Boolean!",
    uuid: "UUID!",
    "activity.uuid": "UUID!",
    versionNumber: "Decimal!",
    completionPercentage: "Decimal!",
    "createdByUser.fullName": "String!",
    "activity.project.uuid": "UUID!",
    changeSummary: "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const activityUuidVar = req.activityUuid ? `request: { activityUuid: "${req.activityUuid}"}, ` : "";

  const QUERY = `
    query(${variablesBlock}) {
      searchActivityHistory(
        ${activityUuidVar},
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            uuid
            versionNumber
            changeSummary
            completionPercentage
            createdAt
            updatedAt
            isCurrent
            isDraft
            isUnderReview
            createdByUser {
              fullName
            }
            activity {
              uuid
              project {
                displayName
                uuid
              }
              group {
                uuid
              }
              activityDefinition {
                displayName
                uuid
              }
            }
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchActivityHistory as SearchResultsGraphQL<
        SearchActivityHistoryResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchProjectDocumentHistory = async (
  req: SearchProjectDocumentHistoryRequest
): Promise<BaseResponseWithSingle<SearchProjectDocumentHistoryResponse>> => {
  const graphqlTypes = {
    "activity.displayName": "String!",
    "activity.versionNumber": "Decimal!",
    "activity.isKey": "Boolean!",
    "projectDocument.externalParty": "String",
    "projectDocument.version": "Int",
    "projectDocument.standardApproved": "Boolean!",
    "projectDocument.visibility": "String!",
    "projectDocument.createdByUser.fullName": "String!",
    "projectDocument.file.filename": "String!",
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.projectDocumentUuid = req.projectDocumentUuid;

  const QUERY = `
    query($projectDocumentUuid: UUID!, ${variablesBlock}) {
      searchProjectDocumentHistory(
        projectDocumentUuid: $projectDocumentUuid
        ${queryBlock}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
           activity {
             displayName
             variant
             isKey
             versionNumber
           }
           projectDocument {
            uuid
            groupId
            standardApproved
            visibility
            version
            type
            variant
            customVariant
            externalParty
            externalReference
            rowVersion
            file {
              url,
              filename
            }
            createdAt
            createdByUser {
              firstName
              lastName
              fullName
            }
           }
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjectDocumentHistory as SearchResultsGraphQL<
        SearchProjectDocumentHistoryResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

interface GetActivityAggregateResponseGraphQL {
  activityAggregate: GetActivityAggregateResponse[];
}

export const getActivityAggregate = async (
  req: GetActivityAggregateRequest
): Promise<BaseResponseWithMultiple<GetActivityAggregateResponse>> => {
  const QUERY = gql`
    query (
      $filterBy: String
      $filterOperator: String
      $filterValue: String
      $groupBy: String
      $aggregate: String
      $aggregation: String
    ) {
      activityAggregate(
        request: {
          filterBy: $filterBy
          filterOperator: $filterOperator
          filterValue: $filterValue
          groupBy: $groupBy
          aggregate: $aggregate
          aggregation: $aggregation
        }
      ) {
        key
        value
      }
    }
  `;
  return apolloPrivate
    .query<GetActivityAggregateResponseGraphQL>({
      query: QUERY,
      variables: {
        filterBy: req.filterBy,
        filterOperator: req.filterOperator,
        filterValue: req.filterValue,
        groupBy: req.groupBy,
        aggregate: req.aggregate,
        aggregation: req.aggregation,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.activityAggregate,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetActivityDetailsResponseGraphQL {
  activityDetails: GetActivityDetailsResponse[];
}

export const getActivityDetails = async (
  req: GetActivityDetailsRequest
): Promise<BaseResponseWithSingle<GetActivityDetailsResponse>> => {
  const graphqlTypes = {
    "project.uuid": "UUID!",
    "project.displayName": "String!",
    createdAt: "Date!",
    status: "String!",
    variant: "String!",
    "activityDefinition.displayName": "String!",
    "currentVersion.createdByUser.fullName": "String!",
    "currentVersion.createdAt": "Date!",
    "currentVersion.versionNumber": "String!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.activityUuid = req.activityUuid;
  const QUERY = `
    query($activityUuid: UUID!, ${variablesBlock}) {
      activityDetails(request: { activityUuid: $activityUuid ${queryBlock}})
        {
        uuid
        groupUuid
        variant
        status
        createdAt
        isUnderReview
        cachedCompletionPercentage
        rowVersion
        activityDefinition {
          displayName
          uuid
        }
        project {
          displayName
          uuid
          type {
            uuid
          }
          developer {
            uuid
            organisationUuid
          }
          verifier {
            uuid
            organisationUuid
            supportsDigitalVerification
          }
        }
        activityDefinitionVersion {
          uuid
          versionNumber
          isManuallyApproved
        }
        createdByUser {
          firstName
          fullName
          lastName
        }
        currentVersion {
          createdAt
          uuid
          versionNumber
          createdByUser {
              firstName
              fullName
              lastName
            }
        }
        draftVersion {
          createdAt
          uuid
          previousActivityHistoryUuid
          versionNumber
          createdByUser {
              firstName
              fullName
              lastName
          }
        }
      }
    }`;

  return apolloPrivate
    .query<GetActivityDetailsResponseGraphQL>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.activityDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetActivityDefinitionVersionDetailsResponseGraphQL {
  activityDefinitionVersionDetails: GetActivityDefinitionVersionDetailsResponse[];
}

export const getActivityDefinitionVersionDetails = async (
  req: GetActivityDefinitionVersionDetailsRequest
): Promise<BaseResponseWithSingle<GetActivityDefinitionVersionDetailsResponse>> => {
  const graphqlTypes = {
    activityDefinitionVersionUuid: "UUID!",
    activityHistoryUuid: "UUID!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.activityDefinitionVersionUuid = req.activityDefinitionVersionUuid;
  variables.activityHistoryUuid = req.activityHistoryUuid;
  const QUERY = gql`
    query ($activityDefinitionVersionUuid: UUID!, $activityHistoryUuid: UUID!, ${variablesBlock}) {
      activityDefinitionVersionDetails(
       request: { activityDefinitionVersionUuid: $activityDefinitionVersionUuid, activityHistoryUuid: $activityHistoryUuid ${queryBlock}}
       ) {
        activityDefinition {
          displayName
          hasVariant
          uuid
        }
        definition
        isManuallyApproved
        uuid
        validFrom
        validTo
        versionNumber
      }
    }
  `;
  return apolloPrivate
    .query<GetActivityDefinitionVersionDetailsResponseGraphQL>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: {
          ...response.data.activityDefinitionVersionDetails[0],
          definition: JSON.parse(response.data.activityDefinitionVersionDetails[0].definition, jsonReviver),
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetActivityHistoryResponseGraphQL {
  activityHistoryDetails: GetActivityHistoryDetailsResponse[];
}

export const getActivityHistoryDetails = async (
  req: GetActivityHistoryDetailsRequest
): Promise<BaseResponseWithSingle<GetActivityHistoryDetailsResponse>> => {
  const graphqlTypes = {
    isCurrent: "Boolean!",
    isDraft: "Boolean!",
    uuid: "UUID!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);
  variables.activityHistoryUuid = req.activityHistoryUuid;
  const QUERY = `
    query($activityHistoryUuid: UUID!, ${variablesBlock}) {
      activityHistoryDetails( activityHistoryUuid: $activityHistoryUuid ${queryBlock}) {
        activity {
          activityDefinition {
            displayName
            uuid
          }
          activityDefinitionVersion {
            uuid
            versionNumber
          }
          project {
            displayName
            uuid
          }
          group {
            displayName
            externalReference
            uuid
          }
          rowVersion
          status
          uuid
          variant
        }
        changeSummary
        completionPercentage
        createdAt
        createdByUser {
          avatar {
            url
          }
          firstName
          fullName
          lastName
        }
        documents {
          activityDefinitionDocumentType {
            displayName
            uuid
          }
          activityDocumentHistory {
            file {
              filename
              mimeType
            }
            uuid
            variant
            versionNumber
          }
          uuid
        }
        data
        isCurrent
        isDraft
        isUnderReview
        previousActivityHistoryUuid
        rowVersion
        uuid
        versionNumber
      }
    }`;

  return apolloPrivate
    .query<GetActivityHistoryResponseGraphQL>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: {
          ...response.data.activityHistoryDetails[0],
          data: JSON.parse(response.data.activityHistoryDetails[0].data, jsonReviver),
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchActivityDocuments = async (
  req: SearchActivityDocumentsRequest
): Promise<BaseResponseWithSingle<SearchActivityDocumentsResponse>> => {
  const graphqlTypes = {
    "activityDefinitionDocumentType.displayName": "String!",
    "activityDefinitionDocumentType.isGenerated": "Boolean!",
    "activityDefinitionDocumentType.isMaster": "Boolean!",
    "activityDocument.variant": "String!",
    "activityDocument.status": "String!",
    "activityDocument.versionNumber": "Decimal!",
    "activityDocument.createdAt": "Date!",
    "activityDocument.createdByUser.fullName": "String!",
    "activityDefinitionVersionDocumentType.isKey": "Boolean!",
    "activity.project.uuid": "UUID!",
    "file.filename": "String!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  variables.currentOnly = req.currentOnly;
  variables.activityUuid = req.activityUuid;
  variables.activityHistoryUuid = req.activityHistoryUuid;
  variables.activityDocumentHistoryUuid = req.activityDocumentHistoryUuid;

  const QUERY = `
    query($currentOnly: Boolean!, $activityUuid: UUID,
    $activityHistoryUuid: UUID,
    $activityDocumentHistoryUuid: UUID, ${variablesBlock}) {
      searchActivityDocuments(request: { currentOnly: $currentOnly, activityDocumentHistoryUuid: $activityDocumentHistoryUuid, activityHistoryUuid: $activityHistoryUuid, activityUuid: $activityUuid }
         ${queryBlock})
      {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            activity {
              uuid
            }
            activityDefinitionDocumentType {
              displayName
              uuid
            }
            activityDefinitionVersionDocumentType {
              isKey
              uuid
            }
            activityDocument {
              createdAt
              createdByUser {
                avatar {
                  url
                }
                firstName
                fullName
                lastName
              }
              status
              uuid
              variant
              versionNumber
            }
            activityHistory {
              uuid
            }
            file {
              filename
              mimeType
            }
            uuid
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchActivityDocuments as SearchResultsGraphQL<
        SearchActivityDocumentsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchActivityDefinitionDocumentTypes = async (
  req: SearchActivityDefinitionDocumentTypesRequest
): Promise<BaseResponseWithSingle<SearchActivityDefinitionDocumentTypesResponse>> => {
  const graphqlTypes = {
    activityDefinitionUuid: "UUID",
    isGenerated: "Boolean!",
    "activityDefinitionVersionDocumentTypes.some.isKey": "Boolean!",
    "activityDefinitionVersionDocumentTypes.some.templateFileUuid": "UUID",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `query(${variablesBlock}) {
  searchActivityDefinitionDocumentTypes(${queryBlock}) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges{
      cursor
      node {
        id
        uuid
        activityDefinitionUuid
        displayName
        isGenerated
        isMaster
        isPerProject
        rowVersion
        activityDefinitionVersionDocumentTypes {
         uuid
         activityDefinitionVersionUuid
         templateFileUuid
         isKey
         hasVariant
        }
      }
    }
  }
 }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchActivityDefinitionDocumentTypes as SearchResultsGraphQL<
        SearchActivityDefinitionDocumentTypesResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

interface GetCurrentUserProjectPermissionsResponseGraphQL {
  currentUserProjectPermissions: GetCurrentUserProjectPermissionsResponse[];
}
export const getCurrentUserProjectPermissions = async (
  req: GetCurrentUserProjectPermissionsRequest
): Promise<BaseResponseWithMultiple<GetCurrentUserProjectPermissionsResponse>> => {
  const QUERY = gql`
    query ($projectUuids: [UUID!], $groupUuids: [UUID!]) {
      currentUserProjectPermissions(projectUuids: $projectUuids, groupUuids: $groupUuids) {
        projectUuid
        groupUuid
        currentUserPermissions
      }
    }
  `;

  return apolloPrivate
    .query<GetCurrentUserProjectPermissionsResponseGraphQL>({
      query: QUERY,
      variables: {
        projectUuids: req.projectUuids,
        groupUuids: req.groupUuids,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.currentUserProjectPermissions,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetGroupDetailsResponseGraphQL {
  groupDetails: GetGroupDetailsResponse[];
}

export const getGroupDetails = async (
  req: GetGroupDetailsRequest
): Promise<BaseResponseWithSingle<GetGroupDetailsResponse>> => {
  const variables = { projectGroupUuid: req.projectGroupUuid };

  const QUERY = gql`
    query ($projectGroupUuid: UUID!) {
      groupDetails(projectGroupUuid: $projectGroupUuid) {
        externalParty
        externalReference
        groupDescription
        groupGuid
        groupName
        manuallyUpdated
        registryMatch
        type
        rowVersion
        addressCity
        addressCountry
        addressCountryCode
        addressLine1
        addressLine2
        addressLine3
        addressPostcode
        addressRegion
        areaNetHa
        locationCoordinates
        areaGrossHa
        locationGridReference
        projects {
          addressCity
          addressCountry
          addressCountryCode
          addressLine1
          addressLine2
          addressLine3
          addressPostcode
          addressRegion
          areaNetHa
          cachedTotalQuantity
          calculatedContactable
          developer {
            displayName
            listing {
              content
            }
            files {
              file {
                url
              }
              type
            }
            uuid
          }
          displayName
          duration
          locationCoordinates
          locationGridReference
          name
          standardSpecificData
          startDate
          status
          uuid
          listing {
            availableForSale
            content
            pilotProject
            seekingFunding
            showPriceInDirectory
          }
          standard {
            displayName
            uuid
          }
          projectType {
            displayName
            uuid
          }
          projectLocation {
            boundaryData
            locationFileUrl
            rowVersion
            uuid
          }
          validator {
            displayName
            uuid
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<GetGroupDetailsResponseGraphQL>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      if (response.data.groupDetails[0].projects && Array.isArray(response.data.groupDetails[0].projects)) {
        const parsedProjectArr = response.data.groupDetails[0].projects.map((el) => {
          if (el.listing?.content && typeof el.listing?.content === "string") {
            // eslint-disable-next-line no-param-reassign
            el.listing.content = JSON.parse(el.listing.content, jsonReviver);
          }

          if (el.standardSpecificData && typeof el.standardSpecificData === "string") {
            // eslint-disable-next-line no-param-reassign
            el.standardSpecificData = JSON.parse(el.standardSpecificData, jsonReviver);
          }

          return el;
        });

        response.data.groupDetails[0].projects = parsedProjectArr;
      }

      return {
        status: Status.Success,
        data: response.data.groupDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetStandardSpecificSchemaDetailsResponseGraphQL {
  standardSpecificSchemaDetails: GetStandardSpecificSchemaDetailsResponse[];
}

export const getStandardSpecificSchemaDetails = async (
  req: GetStandardSpecificSchemaDetailsRequest
): Promise<BaseResponseWithSingle<GetStandardSpecificSchemaDetailsResponse>> => {
  const QUERY = gql`
    query ($standardSpecificSchemaUuid: UUID!) {
      standardSpecificSchemaDetails(standardSpecificSchemaUuid: $standardSpecificSchemaUuid) {
        definition
        schema
        dateSchema
        issuanceSchema
        standardUuid
        uuid
        validFrom
        validTo
        versionNumber
      }
    }
  `;
  return apolloPrivate
    .query<GetStandardSpecificSchemaDetailsResponseGraphQL>({
      query: QUERY,
      variables: {
        standardSpecificSchemaUuid: req.standardSpecificSchemaUuid,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: {
          ...response.data.standardSpecificSchemaDetails[0],
          definition: JSON.parse(response.data.standardSpecificSchemaDetails[0].definition, jsonReviver),
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetDiscussionThreadsResponseGraphQL {
  discussionThreads: GetDiscussionThreadsResponse[];
}

export const getDiscussionThreads = async (
  req: GetDiscussionThreadsRequest
): Promise<BaseResponseWithMultiple<GetDiscussionThreadsResponse>> => {
  const QUERY = `
    query( $objectUuid: UUID!,
    $objectType: String!,
    $messageLookBack: Boolean!,
    $threadUuids: [UUID!]) {
      discussionThreads(request: {objectUuid: $objectUuid, objectType: $objectType, messageLookBack: $messageLookBack, threadUuids: $threadUuids})
        {
          isResolved
          threadType
          uuid
          visibility
          location
          hasNonDeletedMessagesCreatedByOtherUsers
          messages {
              content
              createdAt
              messageType
              rejectedReason
              status
              uuid
              sourceOrganisationUuid
              acceptedByUser {
                  fullName
              }
              createdByUser {
                  uuid
                  fullName
                  avatar {
                    url
                  }
              }
              rejectedByUser {
                  fullName
              }
              rowVersion
          }
      }
    }`;

  return apolloPrivate
    .query<GetDiscussionThreadsResponseGraphQL>({
      query: gql(QUERY),
      variables: {
        objectUuid: req.objectUuid,
        objectType: req.objectType,
        messageLookBack: req.messageLookBack,
        threadUuids: req.threadUuids,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.discussionThreads,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchDiscussionThreads = async (
  req: SearchDiscussionThreadsRequest
): Promise<BaseResponseWithSingle<SearchDiscussionThreadsResponse>> => {
  const graphqlTypes = {
    subject: "String!",
    location: "String!",
    type: "String!",
    visibility: "String!",
    isResolved: "Boolean!",
    "createdByUser.fullName": "String!",
    "messages.some.createdByUser.uuid": "UUID!",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);
  variables.objectUuid = req.objectUuid;
  variables.objectType = req.objectType;
  variables.isDraft = req.isDraft;
  if (req.includeResolved !== undefined) {
    variables.includeResolved = req.includeResolved;
  }

  const includeResolvedParam = req.includeResolved !== undefined ? ", $includeResolved: Boolean!" : "";
  const includeResolvedArg = req.includeResolved !== undefined ? ", includeResolved: $includeResolved" : "";

  const QUERY = `
    query($objectUuid: UUID!, $objectType: String!, $isDraft: Boolean!${includeResolvedParam}, ${variablesBlock}) {
      searchDiscussionsThreads(
          request: {objectUuid: $objectUuid, objectType: $objectType, isDraft: $isDraft${includeResolvedArg}}
          ${queryBlock}
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            uuid
            createdAt
            isResolved
            lastUpdated
            location
            threadType
            visibility
            currentActivityHistoryUuid
            createdByUser {
                fullName
            }
            messages {
              content
              createdAt
              messageType
              rejectedReason
              status
              uuid
              objectType
              objectUuid
              objectVersionNumber
              sourceOrganisationUuid
              acceptedByUser {
                  fullName
              }
              createdByUser {
                  fullName
                  uuid
              }
              rejectedByUser {
                  fullName
              }
              rowVersion
            }
          }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchDiscussionsThreads as SearchResultsGraphQL<
        SearchDiscussionThreadsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

/* eslint-disable unused-imports/no-unused-vars */
// export const fetchHasUnreadMessages = async (
//   _activityUuid: string,
//   _userUuid: string,
//   _currentOrganisationUuid: string
// ): Promise<boolean> => {
//   return false;
// };
/* eslint-enable unused-imports/no-unused-vars */

interface GetOrganisationsForDiscussionResponseGraphQL {
  organisationsForDiscussion: GetOrganisationsForDiscussionResponse[];
}

export const getOrganisationsForDiscussion = async (
  req: GetOrganisationsForDiscussionRequest
): Promise<BaseResponseWithMultiple<GetOrganisationsForDiscussionResponse>> => {
  const QUERY = gql`
    query ($objectType: String!, $objectUuid: UUID!) {
      organisationsForDiscussion(request: { objectType: $objectType, objectUuid: $objectUuid }) {
        displayName
        type
        uuid
      }
    }
  `;

  return apolloPrivate
    .query<GetOrganisationsForDiscussionResponseGraphQL>({
      query: QUERY,
      variables: {
        objectType: req.objectType,
        objectUuid: req.objectUuid,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.organisationsForDiscussion,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetDevelopmentManagerDetailsResponseGraphQL {
  developmentManagerDetails: GetDevelopmentManagerDetailsResponse[];
}

export const getDevelopmentManagerDetails = async (
  req: GetDevelopmentManagerDetailsRequest
): Promise<BaseResponseWithSingle<GetDevelopmentManagerDetailsResponse>> => {
  const QUERY = getOrganisationDetailsHelper(OrganisationType.DevelopmentManager);

  return apolloPrivate
    .query<GetDevelopmentManagerDetailsResponseGraphQL>({
      query: QUERY,
      variables: { developmentManagerUuid: req.developmentManagerUuid },
    })
    .then((response) => {
      if (response.data.developmentManagerDetails[0].listing?.content)
        response.data.developmentManagerDetails[0].listing.content = JSON.parse(
          response.data.developmentManagerDetails[0].listing.content,
          jsonReviver
        );
      return {
        status: Status.Success,
        data: response.data.developmentManagerDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetAssetManagerDetailsResponseGraphQL {
  assetManagerDetails: GetAssetManagerDetailsResponse[];
}

export const getAssetManagerDetails = async (
  req: GetAssetManagerDetailsRequest
): Promise<BaseResponseWithSingle<GetAssetManagerDetailsResponse>> => {
  const QUERY = getOrganisationDetailsHelper(OrganisationType.AssetManager);

  return apolloPrivate
    .query<GetAssetManagerDetailsResponseGraphQL>({
      query: QUERY,
      variables: { assetManagerUuid: req.assetManagerUuid },
    })
    .then((response) => {
      if (response.data.assetManagerDetails[0].listing?.content)
        response.data.assetManagerDetails[0].listing.content = JSON.parse(
          response.data.assetManagerDetails[0].listing.content,
          jsonReviver
        );
      return {
        status: Status.Success,
        data: response.data.assetManagerDetails[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchInteractions = async (
  req: SearchInteractionsRequest
): Promise<BaseResponseWithSingle<SearchInteractionsResponse>> => {
  const graphqlTypes = {
    objectType: "String!",
    type: "String!",
    objectUuid: "UUID!",
    uuid: "[UUID]",
    "objectInteractions.some.objectUuid": Array.isArray(
      req.filter?.results?.objectInteractions?.some?.objectUuid?.value
    )
      ? "[UUID]"
      : "UUID",
    "objectInteractions.some.endDate": "DateTime",
    "objectInteractions.some.objectType": "String",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query(${variablesBlock}) {
      searchInteractions(
          ${queryBlock}
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
            cursor
            node {
                createdAt
                data
                id
                objectType
                objectUuid
                rowVersion
                type
                uuid
                createdByUser {
                    fullName
                    uuid
                    avatar {
                        url
                    }
                }
                objectInteractions {
                    endDate
                    objectType
                    objectUuid
                    startDate
                }
              }
          }
        }
      }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchInteractions as SearchResultsGraphQL<
        SearchInteractionsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchWorkflowTemplates = async (
  req: SearchWorkflowTemplatesRequest & FilterGroups<SearchWorkflowTemplatesRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchWorkflowTemplatesResponse>> => {
  const graphqlTypes = {
    name: "String!",
    type: "String!",
    "projectType.name": "String!",
    "projectType.uuid": "UUID!",
    taskCount: "String!",
    uuid: "UUID!",
    validFrom: "DateTime",
    validTo: "DateTime",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query(${variablesBlock}) {
      searchWorkflowTemplates(
          ${queryBlock}
      ) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
              cursor
              node {
                  description
                  id
                  isGeneral
                  name
                  rowVersion
                  taskCount
                  uuid
                  validFrom
                  validTo
                  ownerOrganisation {
                      name
                      uuid
                  }
                  projectType {
                      name
                      uuid
                  }
              }
          }
      }
    }

  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchWorkflowTemplates as SearchResultsGraphQL<
        SearchWorkflowTemplatesResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

interface GetWorkflowTemplateResponseGraphQL {
  workflowTemplate: GetWorkflowTemplateResponse[];
}

export const getWorkflowTemplate = async (
  req: GetWorkflowTemplateRequest
): Promise<BaseResponseWithSingle<GetWorkflowTemplateResponse>> => {
  const QUERY = gql`
    query ($workflowTemplateUuid: UUID!) {
      workflowTemplate(request: { workflowTemplateUuid: $workflowTemplateUuid }) {
        description
        id
        isGeneral
        name
        phases {
          keyDates
          phase
          sequence
        }
        rowVersion
        taskCount
        type
        validFrom
        validTo
        organisations {
          accessLevel
          name
          uuid
        }
        projectType {
          name
          uuid
        }
        steps {
          createdByOrganisationUuid
          createdByUserUuid
          defaultIsRepeatable
          defaultPhase
          defaultSequence
          defaultStepName
          rowVersion
          mandatoryTaskCount
          taskCount
          uuid
        }
      }
    }
  `;

  return apolloPrivate
    .query<GetWorkflowTemplateResponseGraphQL>({
      query: QUERY,
      variables: { workflowTemplateUuid: req.workflowTemplateUuid },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.workflowTemplate[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchWorkflowTemplateTasks = async (
  req: SearchWorkflowTemplateTasksRequest
): Promise<BaseResponseWithSingle<SearchWorkflowTemplateTasksResponse>> => {
  const graphqlTypes = {
    "projectType.uuid": "UUID!",
    "defaultStep.uuid": "UUID!",
    templateUuid: "UUID!",
    ownerOrganisationType: "[String]",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query(${variablesBlock}) {
      searchWorkflowTemplateTasks(
          ${queryBlock}
      )  {
        totalCount
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges {
            cursor
            node {
                defaultDeadlineField
                defaultDeadlineValue
                defaultDescription
                defaultIsMandatory
                defaultIsMilestone
                defaultKeyDate
                defaultName
                defaultRepeat
                defaultVisibility
                id
                ownerOrganisationType
                rowVersion
                templateUuid
                uuid
                createdByOrganisationUuid
                createdByUserUuid
                defaultStep {
                    isRepeatable
                    name
                    phase
                    uuid
                    createdByUserUuid
                }
            }
        }
      }
    }

  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchWorkflowTemplateTasks as SearchResultsGraphQL<
        SearchWorkflowTemplateTasksResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const getTaskBoard = async (
  req: GetTaskBoardRequest & FilterGroups<GetTaskBoardRequest["filter"]>
): Promise<BaseResponseWithSingle<GetTaskBoardResponse>> => {
  const graphqlTypes = {
    projectUuid: "UUID",
    dealUuid: "UUID",
    groupUuid: "UUID",
    uuid: "UUID",
    projectDisplayName: "String",
    dealName: "String",
    "organisations.some.organisationUuid": "UUID",
    // Compared with `in`, so the variable is a list.
    "organisations.some.accessLevel": "[String]",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  variables.showComplete = req.showComplete;

  const QUERY = `
    query($showComplete: Boolean!, ${variablesBlock}) {
      taskBoard(
        request: { showComplete: $showComplete }
          ${queryBlock}
      )  {
        totalCount
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges {
            cursor
            node {
                id
                dealUuid
                dealName
                dealRowVersion
                name
                projectCachedPhase
                projectDisplayName
                projectRowVersion
                projectUuid
                groupUuid
                  dates
                  rowVersion
                  uuid
                  workflowTemplateUuid
                  showComplete
                  organisations {
                    accessLevel
                    name
                    organisationUuid
                }
                projectType {
                    name
                    uuid
                }
                steps {
                    createdByOrganisationUuid
                    createdByUserUuid
                    id
                    isComplete
                    isRepeatable
                    mandatoryTaskCount
                    name
                    phase
                    sequence
                    rowVersion
                    taskCount
                    uuid
                }
                standardSpecificSchemaUuid
                phases {
                  phase
                  sequence
                  keyDates
                }
            }
        }
      }
    }

  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.taskBoard as SearchResultsGraphQL<GetTaskBoardResponse["results"][number]>;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchWorkflowTasks = async (
  req: SearchWorkflowTasksRequest,
  statusFilter?: { operator: string; value: string[] }
): Promise<BaseResponseWithSingle<SearchWorkflowTasksResponse>> => {
  const graphqlTypes = {
    // A general task has no step, so `step.uuid` is filtered on null to tell the task types apart —
    // which needs the variable itself to be nullable.
    "step.uuid": req.filter?.results?.step?.uuid?.value === null ? "UUID" : "UUID!",
    "step.phase": "String!",
    name: "String!",
    "assignee.name": "String!",
    "assignee.uuid": Array.isArray(req.filter?.results?.assignee?.uuid?.value) ? "[UUID]" : "UUID",
    status: "String!",
    "updatedByUser.fullName": "String!",
    "ownerOrganisation.name": "String!",
    objectName: "String",
    workflowObjectName: "String",
    workflowObjectUuid: Array.isArray(req.filter?.results?.workflowObjectUuid?.value) ? "[UUID]" : "UUID",
    isMilestone: "Boolean!",
    objectUuid: Array.isArray(req.filter?.results?.objectUuid?.value) ? "[UUID]" : "UUID",
    workflowUuid: Array.isArray(req.filter?.results?.workflowUuid?.value) ? "[UUID]" : "UUID",
    uuid: Array.isArray(req.filter?.results?.uuid?.value) ? "[UUID]" : "UUID",
    deadlineDate: "Date",
    developerDisplayName: "String!",
    "groups.some.groupUuid": "UUID",
    // The uniform parent object, spanning Project / Deal / Landholding.
    parentObjectUuid: Array.isArray(req.filter?.results?.parentObjectUuid?.value) ? "[UUID]" : "UUID",
    parentObjectType: "String",
    parentObjectName: "String",
    "tags.some.tagUuid": Array.isArray(req.filter?.results?.tags?.some?.tagUuid?.value) ? "[UUID]" : "UUID",
    "tags.some.tagName": "String",
  };

  // eslint-disable-next-line prefer-const
  let [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  if (statusFilter !== undefined && statusFilter.value.length > 0) {
    const statusClause = `${statusFilter.operator}: ["${statusFilter.value.join('", "')}"]`;

    if (queryBlock.indexOf("status: {") !== -1) {
      queryBlock = insertAfterSubstring(queryBlock, "status: {", ` ${statusClause}, `);
    } else if (queryBlock.indexOf("where: {") !== -1) {
      queryBlock = insertAfterSubstring(queryBlock, "where: {", ` status: { ${statusClause} } `);
    } else {
      /*
        A request whose `filter.results` is empty gets no `where` block from `generateGraphQLHelpers`
        at all, so there was nothing for the clause to be inserted after — and `insertAfterSubstring`
        returns the string untouched when its target is missing, which dropped the status filter in
        silence. Arguments are order-independent, so the block is appended.
      */
      queryBlock += ` where: { status: { ${statusClause} } }`;
    }
  }
  const QUERY = `
    query( ${variablesBlock}) {
      searchWorkflowTasks(
          ${queryBlock}
      )  {
        totalCount
        aspects {
            tags {
                tagUuid
                tagName
            }
        }
        edges {
            cursor
            node {
                createdAt
                deadlineDate
                description
                developerDisplayName
                groups {
                  groupName
                  groupUuid
                  type
                }
                id
                isMandatory
                isMilestone
                keyDate
                name
                objectType
                objectUuid
                parentObjectType
                parentObjectUuid
                parentObjectName
                tags {
                    tagUuid
                    tagName
                }
                workflowObjectType
                workflowObjectName
                workflowObjectUuid
                reminderDate
                reminderType
                repeat
                resolution
                rowVersion
                status
                updatedAt
                uuid
                workflowUuid
                assignee {
                    name
                    uuid
                }
                ownerOrganisation {
                    name
                    uuid
                }
                createdByOrganisation {
                    name
                    uuid
                }
                createdByUser {
                    fullName
                }
                step {
                    name
                    phase
                    uuid
                }
                updatedByUser {
                    fullName
                }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchWorkflowTasks as SearchResultsGraphQL<
        SearchWorkflowTasksResponse["results"][number]
      > & { aspects?: SearchWorkflowTasksResponse["aspects"] };
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          aspects: { tags: data.aspects?.tags ?? [] },
          results,
        },
      };
    });
};

/**
 * The same `searchWorkflowTasks` connection, selecting only what a roadmap draws a milestone diamond
 * from. It takes the identical request — the filter type map is shared, so any criterion the full
 * search accepts is accepted here — and differs from it in the node selection alone.
 *
 * Worth its own function rather than a flag on `searchWorkflowTasks`: a roadmap reads the milestones
 * of up to 15 objects in one page, and the full node's tags, groups, organisations, audit and
 * reminder fields are all wire it never reads. The `aspects` block is dropped for the same reason —
 * it exists to give the tasks dashboard its tag filter.
 */
export const searchWorkflowTaskMilestones = async (
  req: SearchWorkflowTasksRequest
): Promise<BaseResponseWithSingle<SearchWorkflowTaskMilestonesResponse>> => {
  const graphqlTypes = {
    "step.uuid": req.filter?.results?.step?.uuid?.value === null ? "UUID" : "UUID!",
    "step.phase": "String!",
    name: "String!",
    "assignee.name": "String!",
    "assignee.uuid": "UUID",
    status: "String!",
    "updatedByUser.fullName": "String!",
    "ownerOrganisation.name": "String!",
    objectName: "String",
    workflowObjectName: "String",
    workflowObjectUuid: Array.isArray(req.filter?.results?.workflowObjectUuid?.value) ? "[UUID]" : "UUID",
    isMilestone: "Boolean!",
    objectUuid: Array.isArray(req.filter?.results?.objectUuid?.value) ? "[UUID]" : "UUID",
    workflowUuid: Array.isArray(req.filter?.results?.workflowUuid?.value) ? "[UUID]" : "UUID",
    uuid: Array.isArray(req.filter?.results?.uuid?.value) ? "[UUID]" : "UUID",
    deadlineDate: "Date",
    developerDisplayName: "String!",
    "groups.some.groupUuid": "UUID",
    parentObjectUuid: Array.isArray(req.filter?.results?.parentObjectUuid?.value) ? "[UUID]" : "UUID",
    parentObjectType: "String",
    parentObjectName: "String",
    "tags.some.tagUuid": "UUID",
    "tags.some.tagName": "String",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query( ${variablesBlock}) {
      searchWorkflowTasks(
          ${queryBlock}
      )  {
        totalCount
        edges {
            cursor
            node {
                deadlineDate
                name
                parentObjectUuid
                uuid
                step {
                    phase
                }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchWorkflowTasks as SearchResultsGraphQL<
        SearchWorkflowTaskMilestonesResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

/**
 * Group headers for the Tasks dashboard's List and Gantt views: one row per parent object with its
 * task counts. The `request` input carries the same task-level filter the task `where` is built
 * from, so a header count always describes the rows loaded underneath it (BR-02828).
 */
export const searchWorkflowTaskObjectGroups = async (
  req: SearchWorkflowTaskObjectGroupsRequest
): Promise<BaseResponseWithSingle<SearchWorkflowTaskObjectGroupsResponse>> => {
  // The object filter is a filter over the group rows, not over the tasks they count, so it is
  // passed as the connection's `where` rather than inside `request`.
  const where = Object.entries(req.where ?? {}).reduce<Record<string, Record<string, unknown>>>(
    (criteria, [key, filterCriteria]) =>
      filterCriteria === undefined
        ? criteria
        : { ...criteria, [key]: { [filterCriteria.operator]: filterCriteria.value } },
    {}
  );

  const QUERY = `
    query($first: Int, $after: String, $request: SearchWorkflowTaskObjectGroupsRequestInput!, $where: SearchWorkflowTaskObjectGroupsResponseResultsFilterInput) {
      searchWorkflowTaskObjectGroups(
        first: $first
        after: $after
        request: $request
        where: $where
        order: [{ objectType: ASC }, { objectName: ASC }, { objectUuid: ASC }]
      ) {
        totalCount
        pageInfo {
            hasNextPage
            endCursor
        }
        nodes {
            objectType
            objectUuid
            objectName
            taskCount
            milestoneTaskCount
            overdueTaskCount
            statusCounts {
                status
                count
            }
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        first: req.first,
        after: req.after,
        request: req.request,
        where: Object.keys(where).length > 0 ? where : null,
      },
    })
    .then((response) => {
      const data = response.data.searchWorkflowTaskObjectGroups;

      return {
        status: Status.Success,
        data: {
          paging: {
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            total: data.totalCount,
          },
          results: data.nodes as SearchWorkflowTaskObjectGroupsResponse["results"],
        },
      };
    });
};

export interface SearchWorkflowTasksOutsidePhaseDatesExtension {
  objectUuid: string;
  feasibilityStart: Date | undefined;
  feasibilityEnd: Date | undefined;
  designStart: Date | undefined;
  designEnd: Date | undefined;
  implementationStart: Date | undefined;
  implementationEnd: Date | undefined;
  ongoingMonitoringOverallStart: Date | undefined;
  ongoingMonitoringOverallEnd: Date | undefined;
}

// TODO: Unable to generate the following query using generateGraphQLHelpers, (maybe it is possible but it seems too complex, perhaps we can simplify it later)
export const searchWorkflowTasksOutsidePhaseDates = async (
  req: SearchWorkflowTasksOutsidePhaseDatesExtension
): Promise<BaseResponseWithSingle<SearchWorkflowTasksResponse>> => {
  const QUERY = `
    query(
      $objectUuid: UUID!,
      $feasibilityStart: Date!,
      $feasibilityEnd: Date!,
      $designStart: Date!,
      $designEnd: Date!,
      $implementationStart: Date!,
      $implementationEnd: Date!,
      $ongoingMonitoringOverallStart: Date!,
      $ongoingMonitoringOverallEnd: Date!
    ) {
      searchWorkflowTasks(where: {
        objectUuid: { eq: $objectUuid },
        isMilestone: { eq: true },
        or: [
          {
            and: [
              {
                or: [
                  { deadlineDate: { lte: $feasibilityStart } },
                  { deadlineDate: { gte: $feasibilityEnd } }
                ]
              },
              { step: {phase: { eq: "Feasibility" } } }
            ]
          },
          {
            and: [
              {
                or: [
                  { deadlineDate: { lte: $designStart } },
                  { deadlineDate: { gte: $designEnd } }
                ]
              },
              { step: {phase: { eq: "Design" } } }
            ]
          },
          {
            and: [
              {
                or: [
                  { deadlineDate: { lte: $implementationStart } },
                  { deadlineDate: { gte: $implementationEnd } }
                ]
              },
              { step: {phase: { eq: "Implementation" } } }
            ]
          },
          {
            and: [
              {
                or: [
                  { deadlineDate: { lte: $ongoingMonitoringOverallStart } },
                  { deadlineDate: { gte: $ongoingMonitoringOverallEnd } }
                ]
              },
              { step: {phase: { eq: "Ongoing monitoring" } } }
            ]
          },
        ]
      }) {
        totalCount
        edges {
            cursor
            node {
                createdAt
                deadlineDate
                description
                groups {
                  groupName
                  groupUuid
                  type
                }
                id
                isMandatory
                isMilestone
                keyDate
                name
                objectType
                objectUuid
                reminderDate
                reminderType
                repeat
                resolution
                rowVersion
                status
                updatedAt
                uuid
                workflowUuid
                assignee {
                    name
                    uuid
                }
                ownerOrganisation {
                    name
                    uuid
                }
                createdByOrganisation {
                    name
                    uuid
                }
                createdByUser {
                    fullName
                }
                step {
                    name
                    phase
                    uuid
                }
                updatedByUser {
                    fullName
                }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables: {
        objectUuid: req.objectUuid,
        feasibilityStart: req.feasibilityStart,
        feasibilityEnd: req.feasibilityEnd,
        designStart: req.designStart,
        designEnd: req.designEnd,
        implementationStart: req.implementationStart,
        implementationEnd: req.implementationEnd,
        ongoingMonitoringOverallStart: req.ongoingMonitoringOverallStart,
        ongoingMonitoringOverallEnd: req.ongoingMonitoringOverallEnd,
      },
    })
    .then((response) => {
      const data = response.data.searchWorkflowTasks as SearchResultsGraphQL<
        SearchWorkflowTasksResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          // This query selects no connection aspects — only the dashboard's tag filter needs them.
          aspects: { tags: [] },
          results,
        },
      };
    });
};

export const getAggregateWorkflowTasks = async (
  req: GetAggregateWorkflowTasksRequest
): Promise<BaseResponseWithSingle<GetAggregateWorkflowTasksResponse>> => {
  const graphqlTypes = {};
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  variables.workflowUuid = req.workflowUuid;
  variables.activityUuid = req.activityUuid;
  variables.dealUuid = req.dealUuid;
  variables.projectUuid = req.projectUuid;
  variables.phase = req.phase;

  const QUERY = `
    query($workflowUuid: UUID, $activityUuid: UUID, $projectUuid: UUID, $dealUuid: UUID, $phase: String) {
      aggregateWorkflowTasks(request: {workflowUuid: $workflowUuid, activityUuid: $activityUuid, projectUuid: $projectUuid, dealUuid: $dealUuid, phase: $phase}) {
        blockedTasksCount
        completedTasksCount
        inProgressTasksCount
        inReviewTasksCount
        overdueTasksCount
        todoTasksCount
        unassignedTasksCount
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.aggregateWorkflowTasks[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const getCurrentUserGroupPermission = async (
  req: GetCurrentUserGroupPermissionRequest
): Promise<BaseResponseWithSingle<GetCurrentUserGroupPermissionResponse>> => {
  const QUERY = gql`
    query ($groupUuid: UUID!, $permission: String!) {
      currentUserGroupPermission(groupUuid: $groupUuid, permission: $permission) {
        accessLevel
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables: {
        groupUuid: req.groupUuid,
        permission: req.permission,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.currentUserGroupPermission,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchIssuanceTransactions = async (
  req: SearchIssuanceTransactionsRequest
): Promise<BaseResponseWithSingle<SearchIssuanceTransactionsResponse>> => {
  const graphqlTypes = {
    issuanceUuid: Array.isArray(req.filter?.results?.issuanceUuid?.value) ? "[UUID]" : "UUID",
    "counterParty.name": "String",
    "counterParty.uuid": "UUID",
    type: "String",
    quantity: "Decimal",
    price: "Decimal",
    fees: "Decimal",
    totalValue: "Decimal",
    externalReference: "String",
    "updatedByUser.fullName": "String",
    "createdByUser.fullName": "String",
    parentTransactionUuid: "UUID",
    areaHa: "Decimal",
    "project.uuid": Array.isArray(req.filter?.results?.project?.uuid) ? "[UUID]" : "UUID",
    "project.displayName": "String",
    unitMeasurement: "String",
    uuid: Array.isArray(req.filter?.results?.uuid?.value) ? "[UUID]" : "UUID",
    habitatGroup: "String",
    habitatCondition: "String",
    lpa: "String",
    nca: "String",
    lnrs: "String",
    designatedSite: "String",
    quantityType: "String",
    "project.projectType.displayName": "String",
    vintage: "Decimal",
    distinctiveness: "String",
    adjustedQuantity: "Decimal",
    adjustedValue: "Decimal",
    "broker.name": "String",
    "broker.uuid": "UUID",
    "landholding.uuid": "UUID",
    "landholding.name": "String",
    issuanceStatus: Array.isArray(req.filter?.results?.issuanceStatus?.value) ? "[String]" : "String",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
      query(${variablesBlock}) {
      searchIssuanceTransactions(
          ${queryBlock}
      )
        {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
          edges {
              cursor
              node {
                  adjustedQuantity
                  adjustedValue
                  areaHa
                  createdAt
                  distinctiveness
                  expiryDate
                  externalReference
                  fees
                  habitatCondition
                  habitatGroup
                  lpa
                  nca
                  lnrs
                  id
                  issuanceUuid
                  price
                  quantity
                  quantityType
                  rowVersion
                  totalValue
                  transactionDate
                  type
                  unitMeasurement
                  updatedAt
                  uuid
                  vintage
                  createdByUser {
                      firstName
                      fullName
                      lastName
                  }
                  project {
                      displayName
                      region
                      uuid
                      projectType {
                          displayName
                          uuid
                      }
                  }
                  updatedByUser {
                      firstName
                      fullName
                      lastName
                  }
                  landholding {
                      name
                      uuid
                  }
                  broker {
                      name
                      uuid
                  }
                  counterParty {
                      name
                      uuid
                  }
                  parentTransactionUuid
                  parentTransactionId
                  verifierName
              }
          }
        }
        }`;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchIssuanceTransactions as SearchResultsGraphQL<
        SearchIssuanceTransactionsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const getPipelineAggregate = async (
  req: GetPipelineAggregateRequest
): Promise<BaseResponseWithSingle<GetPipelineAggregateResponse>> => {
  const graphqlTypes = {};
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = gql`
    query (${variablesBlock}, $groupBy: String!, $filters: [GetPipelineAggregateRequestFilterInput!], $organisationUuid: UUID!, $pipelineUuid: UUID, $aggregation: String) {
    pipelineAggregate(request: { groupBy: $groupBy, filters: $filters, organisationUuid: $organisationUuid, pipelineUuid: $pipelineUuid, aggregation: $aggregation } ${queryBlock}) {
        key
        value
      }
    }
  `;
  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables: {
        ...variables,
        ...{
          organisationUuid: req.organisationUuid,
          pipelineUuid: req.pipelineUuid,
          aggregation: req.aggregation,
          filters: req.filters,
          groupBy: req.groupBy,
        },
      },
    })
    .then((response) => {
      const data = response.data.pipelineAggregate as GetPipelineAggregateResponse["results"];
      return {
        status: Status.Success,
        data: {
          results: data,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchPipelineDeals = async (
  req: SearchPipelineDealsRequest
): Promise<BaseResponseWithSingle<SearchPipelineDealsResponse>> => {
  const graphqlTypes = {
    uuid: "[UUID]",
    name: "String",
    cachedStage: "String",
    conversionProbability: "Decimal",
    dealLostReason: "String",
    "dealTeam.some.uuid": "UUID",
    description: "String",
    estimatedFees: "Decimal",
    introductionDate: "DateTime",
    investmentValue: "Decimal",
    "leadUser.fullName": "String",
    "leadUser.uuid": "UUID",
    moneyMultiple: "Decimal",
    "pipeline.name": "String",
    "pipeline.uuid": "UUID",
    projectedDpi: "Decimal",
    projectedIrr: "Decimal",
    "relatedObjects.some.location": "String",
    "relatedObjects.some.name": "String!",
    "relatedObjects.some.developerName": "String",
    "relatedObjects.some.objectType": "String",
    "relatedObjects.some.objectUuid": "UUID",
    source: "String",
    status: "String",
    targetCloseDate: "DateTime",
    targetReturns: "Decimal",
    "types.some.name": "String",
    "workflow.workflowTemplateUuid": "UUID",
    "workflow.workflowUuid": "UUID",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  variables.organisationUuid = req.organisationUuid;

  const QUERY = gql`
    query($organisationUuid: UUID!, ${variablesBlock}) {
      searchPipelineDeals(
          request: { organisationUuid: $organisationUuid }
          ${queryBlock}
      )
        {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges {
          cursor
          node {
                createdAt
                updatedAt
                cachedStage
                conversionProbability
                dealDates
                dealLostReason
                dealTeam {
                  uuid
                }
                description
                estimatedFees
                introductionDate
                investmentValue
                moneyMultiple
                name
                projectedDpi
                projectedIrr
                source
                status
                targetCloseDate
                targetReturns
                types {
                  name
                }
                uuid
                leadUser {
                  fullName
                  uuid
                }
                pipeline {
                  name
                  uuid
                }
                relatedObjects {
                  name
                  developerName
                  location
                  objectType
                  objectUuid
                }
                workflow {
                  workflowTemplateUuid
                  workflowUuid
                }
            }
        }
        aspects {
          pipelines {
            uuid
            name
          }
        }
      }
    }`;

  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      const data = response.data.searchPipelineDeals as SearchResultsGraphQL<
        SearchPipelineDealsResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
          aspects: response.data.searchPipelineDeals.aspects as SearchPipelineDealsResponse["aspects"],
        },
      };
    });
};

interface GetDealResponseGraphQL {
  deal: GetDealResponse | GetDealResponse[];
}

export const getDeal = async (req: GetDealRequest): Promise<BaseResponseWithSingle<GetDealResponse>> => {
  const QUERY = gql`
    query Deal($dealUuid: UUID!) {
      deal(request: { dealUuid: $dealUuid }) {
        uuid
        rowVersion
        conversionProbability
        createdAt
        dealDates
        description
        estimatedFees
        introductionDate
        investmentValue
        moneyMultiple
        name
        projectIrr
        projectedDpi
        source
        stage
        status
        targetCloseDate
        targetReturns
        type
        unitQuantity
        dealSpecificData {
          equity
          landAcquisition
          loan
          revenueShare
          unitPurchase
        }
        leadUser {
          uuid
          email
          fullName
          avatar {
            url
          }
        }
        relatedObjects {
          objectType
          objectUuid
          collaborator {
            name
          }
          landholding {
            displayName
            calculatedTotalProjects
            location {
              addressCountry
              addressRegion
              cachedAreaNetHa
              locationCoordinates
            }
          }
          project {
            displayName
            developer {
              displayName
              email
              phoneNumber
            }
            locationCoordinates
            phase
            region
            standard {
              displayName
            }
            type {
              displayName
            }
          }
        }
        pipeline {
          currentPredictedReturns
          name
          targetReturns
          type
        }
        usersInvolved {
          uuid
          email
          fullName
          role
        }
      }
    }
  `;

  return apolloPrivate
    .query<GetDealResponseGraphQL>({
      query: QUERY,
      variables: {
        dealUuid: req.dealUuid,
      },
    })
    .then((response) => {
      const deal = Array.isArray(response.data.deal) ? response.data.deal[0] : response.data.deal;
      return {
        status: Status.Success,
        data: deal,
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

interface GetPortfolioResponseGraphQL {
  portfolio: GetPortfolioResponse[];
}

export const getPortfolio = async (req: GetPortfolioRequest): Promise<BaseResponseWithSingle<GetPortfolioResponse>> => {
  const QUERY = gql`
    query ($portfolioUuid: UUID, $organisationUuid: UUID) {
      portfolio(request: { portfolioUuid: $portfolioUuid, organisationUuid: $organisationUuid }) {
        currentNav
        currentSize
        endDate
        name
        startDate
        targetIrr
        targetSize
        type
        fund {
          currentSize
          endDate
          name
          pipelineSize
          startDate
          strategy
          structure
          targetSize
          type
        }
        leadUser {
          email
          fullName
          avatar {
            url
          }
        }
      }
    }
  `;
  return apolloPrivate
    .query<GetPortfolioResponseGraphQL>({
      query: QUERY,
      variables: {
        portfolioUuid: req.portfolioUuid,
        organisationUuid: req.organisationUuid,
      },
    })
    .then((response) => {
      return {
        status: Status.Success,
        data: response.data.portfolio[0],
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchDealSpecificSchemas = async (
  req: SearchDealSpecificSchemasRequest
): Promise<BaseResponseWithSingle<SearchDealSpecificSchemasResponse>> => {
  const graphqlTypes = {
    dealSpecificSchemaUuid: "UUID",
    dealType: "String",
  };
  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = gql`
    query(${variablesBlock}) {
      searchDealSpecificSchemas(
          ${queryBlock}
      )
        {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          totalCount
          edges {
              cursor
              node {
                  dealSpecificSchemaUuid
                  dealType
                  definition
              }
          }
        }
    }`;

  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      const data = response.data.searchDealSpecificSchemas as SearchResultsGraphQL<
        SearchDealSpecificSchemasResponse["results"][number]
      >;
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    });
};

export const searchAclEntries = async (
  req: SearchAclEntriesRequest
): Promise<BaseResponseWithMultiple<SearchAclEntriesResponse>> => {
  const queryVariables = req.subjectUuid ? "$resourceUuid: UUID!, $subjectUuid: UUID" : "$resourceUuid: UUID!";
  const requestArgs = req.subjectUuid
    ? "resourceUuid: $resourceUuid, subjectUuid: $subjectUuid"
    : "resourceUuid: $resourceUuid";

  const QUERY = gql`
    query (${queryVariables}) {
      searchAclEntries(request: { ${requestArgs} }) {
        edges {
          node {
            subjectUuid
            resourceUuid
            permissions
          }
        }
      }
    }
  `;

  const variables: Record<string, string> = { resourceUuid: req.resourceUuid };
  if (req.subjectUuid) variables.subjectUuid = req.subjectUuid;

  return apolloPrivate
    .query<any>({
      query: QUERY,
      variables,
    })
    .then((response) => {
      const edges = response.data.searchAclEntries?.edges ?? [];
      return {
        status: Status.Success,
        data: edges.map((e: any) => e.node as SearchAclEntriesResponse),
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchNotifications = async (
  req: SearchNotificationsRequest
): Promise<BaseResponseWithSingle<SearchNotificationsResponse>> => {
  const graphqlTypes = {
    deliveryType: "String",
    isDismissed: "Boolean",
    isRead: "Boolean",
    "raisedByUser.firstName": "String!",
    "raisedByUser.fullName": "String!",
    "raisedByUser.lastName": "String!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes, false);

  const QUERY = `
    query(${variablesBlock}) {
      searchNotifications(
        ${queryBlock}
      ) {
        totalCount
        aspects {
          unreadCount
          hasUnread
        }
        edges {
          cursor
          node {
            createdAt
            dismissedAt
            isDismissed
            isRead
            message
            messageSubject
            objectType
            objectUuid
            raisedByType
            raisedByUserUuid
            readAt
            url
            uuid
            raisedByUser {
              firstName
              fullName
              lastName
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchNotifications as SearchResultsGraphQL<
        SearchNotificationsResponse["results"][number]
      >;
      const aspects = response.data.searchNotifications.aspects as SearchNotificationsResponse["aspects"];
      const results = data.edges.map((e) => e.node);

      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
          aspects: {
            unreadCount: aspects.unreadCount,
            hasUnread: aspects.hasUnread,
          },
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};

export const searchProjectLocations = async (
  req: SearchProjectLocationsRequest & FilterGroups<SearchProjectLocationsRequest["filter"]>
): Promise<BaseResponseWithSingle<SearchProjectLocationsResponse>> => {
  const graphqlTypes = {
    name: "String!",
    status: "String!",
    locationCoordinates: "String!",
    "developer.uuid": "UUID!",
    responsibleOwnerOrganisationUuid: "UUID!",
    phase: "String!",
    addressCountryCode: "String!",
    addressCity: "String!",
  };

  const [queryBlock, variablesBlock, variables] = generateGraphQLHelpers(req, graphqlTypes);

  const QUERY = `
    query SearchProjectLocations( ${variablesBlock}) {
      searchProjects(
        ${queryBlock}
      ) {
        edges {
          node {
            uuid
            name
            status
            locationCoordinates
            phase
            addressCountryCode
            addressCity
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  `;

  return apolloPrivate
    .query<any>({
      query: gql(QUERY),
      variables,
    })
    .then((response) => {
      const data = response.data.searchProjects as SearchResultsGraphQL<
        SearchProjectLocationsResponse["results"][number]
      >;

      const results = data.edges.map((e) => e.node);
      return {
        status: Status.Success,
        data: {
          paging: {
            startCursor: data.pageInfo.startCursor,
            endCursor: data.pageInfo.endCursor,
            hasNextPage: data.pageInfo.hasNextPage,
            hasPreviousPage: data.pageInfo.hasPreviousPage,
            total: data.totalCount,
          },
          results,
        },
      };
    })
    .catch((error) => {
      const errors = error?.networkError?.result?.errors;
      const ret = errors
        ? errors.map(
            (e: any) =>
              ({
                property: e.property,
                path: e.path,
                parameters: e.extensions,
                message: e.message,
                code: e.code,
              }) as ServiceError
          )
        : [];
      return {
        status: Status.Error,
        errors: ret,
      };
    });
};
